var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundWidgetEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 160,
    viewBox: "0 0 854 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20994_306983)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20994_306983",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 854,
    height: 160
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M854 0H0V160H854V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20994_306983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M814.6 -1.20007H-19.5V175.8H814.6V-1.20007Z",
    fill: "#009569"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.801 103.9C931.801 220.6 699.401 201.2 412.801 201.2C126.201 201.2 -106.199 220.6 -106.199 103.9C-106.199 -12.8 126.201 -107.4 412.801 -107.4C699.401 -107.4 931.801 -12.8 931.801 103.9Z",
    className: "illustration_secondary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 66.6096L569.186 66.6096L569.186 52.2096L518.086 52.2096L518.086 66.6096Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 63.9097L566.531 63.9097L566.531 55.1097L562.431 55.1097L562.431 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 63.9097L561.131 63.9097L561.131 55.1097L557.031 55.1097L557.031 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 63.9097L555.729 63.9097L555.729 55.1097L551.63 55.1097L551.63 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 63.9097L550.329 63.9097L550.329 55.1097L546.229 55.1097L546.229 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 63.9097L544.929 63.9097L544.929 55.1097L540.829 55.1097L540.829 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 63.9097L539.528 63.9097L539.528 55.1097L535.428 55.1097L535.428 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 63.9097L534.127 63.9097L534.127 55.1097L530.027 55.1097L530.027 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 63.9097L528.727 63.9097L528.727 55.1097L524.627 55.1097L524.627 63.9097Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 63.9097L566.373 63.9097L566.373 55.1097L562.273 55.1097L562.273 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 63.9097L560.973 63.9097L560.973 55.1097L556.873 55.1097L556.873 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 63.9097L555.571 63.9097L555.571 55.1097L551.471 55.1097L551.471 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 63.9097L550.171 63.9097L550.171 55.1097L546.071 55.1097L546.071 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 63.9097L544.771 63.9097L544.771 55.1097L540.671 55.1097L540.671 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 63.9097L539.369 63.9097L539.369 55.1097L535.269 55.1097L535.269 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 63.9097L533.969 63.9097L533.969 55.1097L529.869 55.1097L529.869 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 63.9097L528.568 63.9097L528.568 55.1097L524.468 55.1097L524.468 63.9097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 64.6116L566.373 64.6116L566.373 63.8116L562.273 63.8116L562.273 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 64.6116L560.973 64.6116L560.973 63.8116L556.873 63.8116L556.873 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 64.6116L555.571 64.6116L555.571 63.8116L551.471 63.8116L551.471 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 64.6116L550.171 64.6116L550.171 63.8116L546.071 63.8116L546.071 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 64.6116L544.771 64.6116L544.771 63.8116L540.671 63.8116L540.671 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 64.6116L539.369 64.6116L539.369 63.8116L535.269 63.8116L535.269 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 64.6116L533.969 64.6116L533.969 63.8116L529.869 63.8116L529.869 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 64.6116L528.568 64.6116L528.568 63.8116L524.468 63.8116L524.468 64.6116Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 64.6116L566.869 64.6116L566.869 63.8116L562.769 63.8116L562.769 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 64.6116L561.469 64.6116L561.469 63.8116L557.369 63.8116L557.369 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 64.6116L556.067 64.6116L556.067 63.8116L551.967 63.8116L551.967 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 64.6116L550.667 64.6116L550.667 63.8116L546.567 63.8116L546.567 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 64.6116L545.267 64.6116L545.267 63.8116L541.167 63.8116L541.167 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 64.6116L539.866 64.6116L539.866 63.8116L535.766 63.8116L535.766 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 64.6116L534.465 64.6116L534.465 63.8116L530.365 63.8116L530.365 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 64.6116L529.064 64.6116L529.064 63.8116L524.964 63.8116L524.964 64.6116Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 57.7546L528.636 57.7546L528.636 55.0546L524.436 55.0546L524.436 57.7546Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 60.8173L534.02 60.8173L534.02 55.1173L529.82 55.1173L529.82 60.8173Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 60.2913L539.431 60.2913L539.431 55.0913L535.231 55.0913L535.231 60.2913Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 57.9449L544.832 57.9449L544.832 55.0449L540.632 55.0449L540.632 57.9449Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 56.995L550.233 56.995L550.233 55.095L546.033 55.095L546.033 56.995Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 55.8728L555.634 55.8728L555.634 55.0728L551.434 55.0728L551.434 55.8728Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.834 57.7546L561.034 57.7546L561.034 55.0546L556.834 55.0546L556.834 57.7546Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 61.7466L566.435 61.7466L566.435 55.0466L562.235 55.0466L562.235 61.7466Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 52.2999H510.301V66.6999H518.201V52.2999Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.001 63.5H512.501V64.3H515.001V63.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 64.5H511.101V65.3H513.601V64.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.301 64.5H513.801V65.3H516.301V64.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 52.3105L570.023 52.3105L570.023 51.7105L518.123 51.7105L518.123 52.3105Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 51.5969L570.023 51.5969L570.023 50.8969L518.123 50.8969L518.123 51.5969Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 51.6H509.801V52.2H518.101V51.6Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 51H509.801V51.7H518.101V51Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 51H509.801V52.3H518.101V51Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 82.3405L569.186 82.3405L569.186 67.9405L518.086 67.9405L518.086 82.3405Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 79.5404L566.531 79.5404L566.531 70.7404L562.431 70.7404L562.431 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 79.5404L561.131 79.5404L561.131 70.7404L557.031 70.7404L557.031 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 79.5404L555.729 79.5404L555.729 70.7404L551.63 70.7404L551.63 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 79.5404L550.329 79.5404L550.329 70.7404L546.229 70.7404L546.229 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 79.5404L544.929 79.5404L544.929 70.7404L540.829 70.7404L540.829 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 79.5404L539.528 79.5404L539.528 70.7404L535.428 70.7404L535.428 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 79.5404L534.127 79.5404L534.127 70.7404L530.027 70.7404L530.027 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 79.5404L528.727 79.5404L528.727 70.7404L524.627 70.7404L524.627 79.5404Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 79.5404L566.373 79.5404L566.373 70.7404L562.273 70.7404L562.273 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 79.5404L560.973 79.5404L560.973 70.7404L556.873 70.7404L556.873 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 79.5404L555.571 79.5404L555.571 70.7404L551.471 70.7404L551.471 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 79.5404L550.171 79.5404L550.171 70.7404L546.071 70.7404L546.071 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 79.5404L544.771 79.5404L544.771 70.7404L540.671 70.7404L540.671 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 79.5404L539.369 79.5404L539.369 70.7404L535.269 70.7404L535.269 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 79.5404L533.969 79.5404L533.969 70.7404L529.869 70.7404L529.869 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 79.5404L528.568 79.5404L528.568 70.7404L524.468 70.7404L524.468 79.5404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 80.3424L566.373 80.3424L566.373 79.5424L562.273 79.5424L562.273 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 80.3424L560.973 80.3424L560.973 79.5424L556.873 79.5424L556.873 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 80.3424L555.571 80.3424L555.571 79.5424L551.471 79.5424L551.471 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 80.3424L550.171 80.3424L550.171 79.5424L546.071 79.5424L546.071 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 80.3424L544.771 80.3424L544.771 79.5424L540.671 79.5424L540.671 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 80.3424L539.369 80.3424L539.369 79.5424L535.269 79.5424L535.269 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 80.3424L533.969 80.3424L533.969 79.5424L529.869 79.5424L529.869 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 80.3424L528.568 80.3424L528.568 79.5424L524.468 79.5424L524.468 80.3424Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 80.3424L566.869 80.3424L566.869 79.5424L562.769 79.5424L562.769 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 80.3424L561.469 80.3424L561.469 79.5424L557.369 79.5424L557.369 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 80.3424L556.067 80.3424L556.067 79.5424L551.967 79.5424L551.967 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 80.3424L550.667 80.3424L550.667 79.5424L546.567 79.5424L546.567 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 80.3424L545.267 80.3424L545.267 79.5424L541.167 79.5424L541.167 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 80.3424L539.866 80.3424L539.866 79.5424L535.766 79.5424L535.766 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 80.3424L534.465 80.3424L534.465 79.5424L530.365 79.5424L530.365 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 80.3424L529.064 80.3424L529.064 79.5424L524.964 79.5424L524.964 80.3424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 72.0447L528.636 72.0447L528.636 70.7447L524.436 70.7447L524.436 72.0447Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 71.6647L534.02 71.6647L534.02 70.6647L529.82 70.6647L529.82 71.6647Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 72.0447L539.431 72.0447L539.431 70.7447L535.231 70.7447L535.231 72.0447Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 72.1396L544.832 72.1396L544.832 70.7396L540.632 70.7396L540.632 72.1396Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 71.6647L550.233 71.6647L550.233 70.6647L546.033 70.6647L546.033 71.6647Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 71.5037L555.634 71.5037L555.634 70.7037L551.434 70.7037L551.434 71.5037Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.773 71.968L560.973 71.968L560.973 70.668L556.773 70.668L556.773 71.968Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 71.9626L566.435 71.9626L566.435 70.6626L562.235 70.6626L562.235 71.9626Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 67.9H510.301V82.3H518.201V67.9Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.001 79.2H512.501V80H515.001V79.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 80.2H511.101V81H513.601V80.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 67.9414L570.023 67.9414L570.023 67.3414L518.123 67.3414L518.123 67.9414Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 67.3278L570.023 67.3278L570.023 66.6278L518.123 66.6278L518.123 67.3278Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 67.2999H509.801V67.8999H518.101V67.2999Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 66.6H509.801V67.3H518.101V66.6Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 66.6H509.801V67.9H518.101V66.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 35.348L569.186 35.348L569.186 20.948L518.086 20.948L518.086 35.348Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 32.548L566.531 32.548L566.531 23.748L562.431 23.748L562.431 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 32.548L561.131 32.548L561.131 23.748L557.031 23.748L557.031 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 32.548L555.729 32.548L555.729 23.748L551.63 23.748L551.63 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 32.548L550.329 32.548L550.329 23.748L546.229 23.748L546.229 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 32.548L544.929 32.548L544.929 23.748L540.829 23.748L540.829 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 32.548L539.528 32.548L539.528 23.748L535.428 23.748L535.428 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 32.548L534.127 32.548L534.127 23.748L530.027 23.748L530.027 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 32.548L528.727 32.548L528.727 23.748L524.627 23.748L524.627 32.548Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 32.548L566.373 32.548L566.373 23.748L562.273 23.748L562.273 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 32.548L560.973 32.548L560.973 23.748L556.873 23.748L556.873 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 32.548L555.571 32.548L555.571 23.748L551.471 23.748L551.471 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 32.548L550.171 32.548L550.171 23.748L546.071 23.748L546.071 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 32.548L544.771 32.548L544.771 23.748L540.671 23.748L540.671 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 32.548L539.369 32.548L539.369 23.748L535.269 23.748L535.269 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 32.548L533.969 32.548L533.969 23.748L529.869 23.748L529.869 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 32.548L528.568 32.548L528.568 23.748L524.468 23.748L524.468 32.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 33.35L566.373 33.35L566.373 32.55L562.273 32.55L562.273 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 33.35L560.973 33.35L560.973 32.55L556.873 32.55L556.873 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 33.35L555.571 33.35L555.571 32.55L551.471 32.55L551.471 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 33.35L550.171 33.35L550.171 32.55L546.071 32.55L546.071 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 33.35L544.771 33.35L544.771 32.55L540.671 32.55L540.671 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 33.35L539.369 33.35L539.369 32.55L535.269 32.55L535.269 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 33.35L533.969 33.35L533.969 32.55L529.869 32.55L529.869 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 33.35L528.568 33.35L528.568 32.55L524.468 32.55L524.468 33.35Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 33.35L566.869 33.35L566.869 32.55L562.769 32.55L562.769 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 33.35L561.469 33.35L561.469 32.55L557.369 32.55L557.369 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 33.35L556.067 33.35L556.067 32.55L551.967 32.55L551.967 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 33.35L550.667 33.35L550.667 32.55L546.567 32.55L546.567 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 33.35L545.267 33.35L545.267 32.55L541.167 32.55L541.167 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 33.35L539.866 33.35L539.866 32.55L535.766 32.55L535.766 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 33.35L534.465 33.35L534.465 32.55L530.365 32.55L530.365 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 33.35L529.064 33.35L529.064 32.55L524.964 32.55L524.964 33.35Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 26.3931L528.636 26.3931L528.636 23.6931L524.436 23.6931L524.436 26.3931Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 29.4556L534.02 29.4556L534.02 23.7556L529.82 23.7556L529.82 29.4556Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 28.9297L539.431 28.9297L539.431 23.7297L535.231 23.7297L535.231 28.9297Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 26.5834L544.832 26.5834L544.832 23.6834L540.632 23.6834L540.632 26.5834Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 25.6333L550.233 25.6333L550.233 23.7333L546.033 23.7333L546.033 25.6333Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 24.5112L555.634 24.5112L555.634 23.7112L551.434 23.7112L551.434 24.5112Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.834 26.3931L561.034 26.3931L561.034 23.6931L556.834 23.6931L556.834 26.3931Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 30.3848L566.435 30.3848L566.435 23.6848L562.235 23.6848L562.235 30.3848Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 20.9H510.301V35.3H518.201V20.9Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.001 32.2H512.501V33H515.001V32.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 33.2H511.101V34H513.601V33.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.301 33.2H513.801V34H516.301V33.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 20.949L570.023 20.949L570.023 20.349L518.123 20.349L518.123 20.949Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 20.3353L570.023 20.3353L570.023 19.6353L518.123 19.6353L518.123 20.3353Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 20.2999H509.801V20.8999H518.101V20.2999Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 19.6H509.801V20.3H518.101V19.6Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 19.6H509.801V20.9H518.101V19.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 50.9789L569.186 50.9789L569.186 36.5789L518.086 36.5789L518.086 50.9789Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 48.1788L566.531 48.1788L566.531 39.3788L562.431 39.3788L562.431 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 48.1788L561.131 48.1788L561.131 39.3788L557.031 39.3788L557.031 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 48.1788L555.729 48.1788L555.729 39.3788L551.63 39.3788L551.63 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 48.1788L550.329 48.1788L550.329 39.3788L546.229 39.3788L546.229 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 48.1788L544.929 48.1788L544.929 39.3788L540.829 39.3788L540.829 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 48.1788L539.528 48.1788L539.528 39.3788L535.428 39.3788L535.428 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 48.1788L534.127 48.1788L534.127 39.3788L530.027 39.3788L530.027 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 48.1788L528.727 48.1788L528.727 39.3788L524.627 39.3788L524.627 48.1788Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 48.1788L566.373 48.1788L566.373 39.3788L562.273 39.3788L562.273 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 48.1788L560.973 48.1788L560.973 39.3788L556.873 39.3788L556.873 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 48.1788L555.571 48.1788L555.571 39.3788L551.471 39.3788L551.471 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 48.1788L550.171 48.1788L550.171 39.3788L546.071 39.3788L546.071 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 48.1788L544.771 48.1788L544.771 39.3788L540.671 39.3788L540.671 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 48.1788L539.369 48.1788L539.369 39.3788L535.269 39.3788L535.269 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 48.1788L533.969 48.1788L533.969 39.3788L529.869 39.3788L529.869 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 48.1788L528.568 48.1788L528.568 39.3788L524.468 39.3788L524.468 48.1788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 48.9808L566.373 48.9808L566.373 48.1808L562.273 48.1808L562.273 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 48.9808L560.973 48.9808L560.973 48.1808L556.873 48.1808L556.873 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 48.9808L555.571 48.9808L555.571 48.1808L551.471 48.1808L551.471 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 48.9808L550.171 48.9808L550.171 48.1808L546.071 48.1808L546.071 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 48.9808L544.771 48.9808L544.771 48.1808L540.671 48.1808L540.671 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 48.9808L539.369 48.9808L539.369 48.1808L535.269 48.1808L535.269 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 48.9808L533.969 48.9808L533.969 48.1808L529.869 48.1808L529.869 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 48.9808L528.568 48.9808L528.568 48.1808L524.468 48.1808L524.468 48.9808Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 48.9808L566.869 48.9808L566.869 48.1808L562.769 48.1808L562.769 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 48.9808L561.469 48.9808L561.469 48.1808L557.369 48.1808L557.369 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 48.9808L556.067 48.9808L556.067 48.1808L551.967 48.1808L551.967 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 48.9808L550.667 48.9808L550.667 48.1808L546.567 48.1808L546.567 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 48.9808L545.267 48.9808L545.267 48.1808L541.167 48.1808L541.167 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 48.9808L539.866 48.9808L539.866 48.1808L535.766 48.1808L535.766 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 48.9808L534.465 48.9808L534.465 48.1808L530.365 48.1808L530.365 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 48.9808L529.064 48.9808L529.064 48.1808L524.964 48.1808L524.964 48.9808Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 40.683L528.636 40.683L528.636 39.383L524.436 39.383L524.436 40.683Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 40.303L534.02 40.303L534.02 39.303L529.82 39.303L529.82 40.303Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 40.683L539.431 40.683L539.431 39.383L535.231 39.383L535.231 40.683Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 40.7782L544.832 40.7782L544.832 39.3782L540.632 39.3782L540.632 40.7782Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 40.303L550.233 40.303L550.233 39.303L546.033 39.303L546.033 40.303Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 40.1421L555.634 40.1421L555.634 39.3421L551.434 39.3421L551.434 40.1421Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.773 40.7064L560.973 40.7064L560.973 39.4064L556.773 39.4064L556.773 40.7064Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 40.6011L566.435 40.6011L566.435 39.3011L562.235 39.3011L562.235 40.6011Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 36.6H510.301V51H518.201V36.6Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.001 47.9H512.501V48.7H515.001V47.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 48.9H511.101V49.7H513.601V48.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 36.5798L570.023 36.5798L570.023 35.9798L518.123 35.9798L518.123 36.5798Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 35.9662L570.023 35.9662L570.023 35.2662L518.123 35.2662L518.123 35.9662Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 36H509.801V36.6H518.101V36Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 35.3H509.801V36H518.101V35.3Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 35.3H509.801V36.6H518.101V35.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 97.9712L569.186 97.9712L569.186 83.5712L518.086 83.5712L518.086 97.9712Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 95.1711L566.531 95.1711L566.531 86.3711L562.431 86.3711L562.431 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 95.1711L561.131 95.1711L561.131 86.3711L557.031 86.3711L557.031 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 95.1711L555.729 95.1711L555.729 86.3711L551.63 86.3711L551.63 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 95.1711L550.329 95.1711L550.329 86.3711L546.229 86.3711L546.229 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 95.1711L544.929 95.1711L544.929 86.3711L540.829 86.3711L540.829 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 95.1711L539.528 95.1711L539.528 86.3711L535.428 86.3711L535.428 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 95.1711L534.127 95.1711L534.127 86.3711L530.027 86.3711L530.027 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 95.1711L528.727 95.1711L528.727 86.3711L524.627 86.3711L524.627 95.1711Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 95.1711L566.373 95.1711L566.373 86.3711L562.273 86.3711L562.273 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 95.1711L560.973 95.1711L560.973 86.3711L556.873 86.3711L556.873 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 95.1711L555.571 95.1711L555.571 86.3711L551.471 86.3711L551.471 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 95.1711L550.171 95.1711L550.171 86.3711L546.071 86.3711L546.071 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 95.1711L544.771 95.1711L544.771 86.3711L540.671 86.3711L540.671 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 95.1711L539.369 95.1711L539.369 86.3711L535.269 86.3711L535.269 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 95.1711L533.969 95.1711L533.969 86.3711L529.869 86.3711L529.869 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 95.1711L528.568 95.1711L528.568 86.3711L524.468 86.3711L524.468 95.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 95.9731L566.373 95.9731L566.373 95.1731L562.273 95.1731L562.273 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 95.9731L560.973 95.9731L560.973 95.1731L556.873 95.1731L556.873 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 95.9731L555.571 95.9731L555.571 95.1731L551.471 95.1731L551.471 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 95.9731L550.171 95.9731L550.171 95.1731L546.071 95.1731L546.071 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 95.9731L544.771 95.9731L544.771 95.1731L540.671 95.1731L540.671 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 95.9731L539.369 95.9731L539.369 95.1731L535.269 95.1731L535.269 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 95.9731L533.969 95.9731L533.969 95.1731L529.869 95.1731L529.869 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 95.9731L528.568 95.9731L528.568 95.1731L524.468 95.1731L524.468 95.9731Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 95.9731L566.869 95.9731L566.869 95.1731L562.769 95.1731L562.769 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 95.9731L561.469 95.9731L561.469 95.1731L557.369 95.1731L557.369 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 95.9731L556.067 95.9731L556.067 95.1731L551.967 95.1731L551.967 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 95.9731L550.667 95.9731L550.667 95.1731L546.567 95.1731L546.567 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 95.9731L545.267 95.9731L545.267 95.1731L541.167 95.1731L541.167 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 95.9731L539.866 95.9731L539.866 95.1731L535.766 95.1731L535.766 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 95.9731L534.465 95.9731L534.465 95.1731L530.365 95.1731L530.365 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 95.9731L529.064 95.9731L529.064 95.1731L524.964 95.1731L524.964 95.9731Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 89.637L528.636 89.637L528.636 86.337L524.436 86.337L524.436 89.637Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 88.0588L534.02 88.0588L534.02 86.3588L529.82 86.3588L529.82 88.0588Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 89.146L539.431 89.146L539.431 86.346L535.231 86.346L535.231 89.146Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 89.7421L544.832 89.7421L544.832 86.3421L540.632 86.3421L540.632 89.7421Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 88.9004L550.233 88.9004L550.233 86.3004L546.033 86.3004L546.033 88.9004Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 88.2693L555.634 88.2693L555.634 86.3693L551.434 86.3693L551.434 88.2693Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.834 87.3018L561.034 87.3018L561.034 86.3018L556.834 86.3018L556.834 87.3018Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 87.6174L566.435 87.6174L566.435 86.3174L562.235 86.3174L562.235 87.6174Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 83.6H510.301V98H518.201V83.6Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 95.8999H511.101V96.6999H513.601V95.8999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.301 95.8999H513.801V96.6999H516.301V95.8999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 83.5721L570.023 83.5721L570.023 82.9721L518.123 82.9721L518.123 83.5721Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 82.9585L570.023 82.9585L570.023 82.2585L518.123 82.2585L518.123 82.9585Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 83H509.801V83.6H518.101V83Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 82.2999H509.801V82.9999H518.101V82.2999Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 82.2999H509.801V83.5999H518.101V82.2999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.086 113.602L569.186 113.602L569.186 99.2022L518.086 99.2022L518.086 113.602Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.431 110.902L566.531 110.902L566.531 102.102L562.431 102.102L562.431 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.031 110.902L561.131 110.902L561.131 102.102L557.031 102.102L557.031 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.63 110.902L555.729 110.902L555.729 102.102L551.63 102.102L551.63 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.229 110.902L550.329 110.902L550.329 102.102L546.229 102.102L546.229 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.829 110.902L544.929 110.902L544.929 102.102L540.829 102.102L540.829 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.428 110.902L539.528 110.902L539.528 102.102L535.428 102.102L535.428 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.027 110.902L534.127 110.902L534.127 102.102L530.027 102.102L530.027 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.627 110.902L528.727 110.902L528.727 102.102L524.627 102.102L524.627 110.902Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 110.902L566.373 110.902L566.373 102.102L562.273 102.102L562.273 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 110.902L560.973 110.902L560.973 102.102L556.873 102.102L556.873 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 110.902L555.571 110.902L555.571 102.102L551.471 102.102L551.471 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 110.902L550.171 110.902L550.171 102.102L546.071 102.102L546.071 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 110.902L544.771 110.902L544.771 102.102L540.671 102.102L540.671 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 110.902L539.369 110.902L539.369 102.102L535.269 102.102L535.269 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 110.902L533.969 110.902L533.969 102.102L529.869 102.102L529.869 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 110.902L528.568 110.902L528.568 102.102L524.468 102.102L524.468 110.902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.273 111.604L566.373 111.604L566.373 110.804L562.273 110.804L562.273 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.873 111.604L560.973 111.604L560.973 110.804L556.873 110.804L556.873 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.471 111.604L555.571 111.604L555.571 110.804L551.471 110.804L551.471 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.071 111.604L550.171 111.604L550.171 110.804L546.071 110.804L546.071 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.671 111.604L544.771 111.604L544.771 110.804L540.671 110.804L540.671 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.269 111.604L539.369 111.604L539.369 110.804L535.269 110.804L535.269 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.869 111.604L533.969 111.604L533.969 110.804L529.869 110.804L529.869 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.468 111.604L528.568 111.604L528.568 110.804L524.468 110.804L524.468 111.604Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.769 111.604L566.869 111.604L566.869 110.804L562.769 110.804L562.769 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.369 111.604L561.469 111.604L561.469 110.804L557.369 110.804L557.369 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.967 111.604L556.067 111.604L556.067 110.804L551.967 110.804L551.967 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.567 111.604L550.667 111.604L550.667 110.804L546.567 110.804L546.567 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.167 111.604L545.267 111.604L545.267 110.804L541.167 110.804L541.167 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.766 111.604L539.866 111.604L539.866 110.804L535.766 110.804L535.766 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.365 111.604L534.465 111.604L534.465 110.804L530.365 110.804L530.365 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.964 111.604L529.064 111.604L529.064 110.804L524.964 110.804L524.964 111.604Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.436 104.747L528.636 104.747L528.636 102.047L524.436 102.047L524.436 104.747Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.82 107.81L534.02 107.81L534.02 102.11L529.82 102.11L529.82 107.81Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.231 107.284L539.431 107.284L539.431 102.084L535.231 102.084L535.231 107.284Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.632 104.937L544.832 104.937L544.832 102.037L540.632 102.037L540.632 104.937Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.033 103.987L550.233 103.987L550.233 102.087L546.033 102.087L546.033 103.987Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.434 102.865L555.634 102.865L555.634 102.065L551.434 102.065L551.434 102.865Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.834 104.747L561.034 104.747L561.034 102.047L556.834 102.047L556.834 104.747Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.235 108.739L566.435 108.739L566.435 102.039L562.235 102.039L562.235 108.739Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.201 99.3H510.301V113.7H518.201V99.3Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.001 110.5H512.501V111.3H515.001V110.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.601 111.5H511.101V112.3H513.601V111.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M516.301 111.5H513.801V112.3H516.301V111.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 99.303L570.023 99.303L570.023 98.703L518.123 98.703L518.123 99.303Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.123 98.5894L570.023 98.5894L570.023 97.8894L518.123 97.8894L518.123 98.5894Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 98.6H509.801V99.2H518.101V98.6Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.101 98H509.801V98.7H518.101V98Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M518.101 98H509.801V99.3H518.101V98Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.648 67.2714L501.348 67.2714L501.348 52.7714L449.648 52.7714L449.648 67.2714Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.533 64.4713L498.733 64.4713L498.733 55.4713L494.533 55.4713L494.533 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.992 64.4713L493.192 64.4713L493.192 55.4713L488.992 55.4713L488.992 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.552 64.4713L487.752 64.4713L487.752 55.4713L483.552 55.4713L483.552 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.112 64.4713L482.312 64.4713L482.312 55.4713L478.112 55.4713L478.112 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.572 64.4713L476.771 64.4713L476.771 55.4713L472.572 55.4713L472.572 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.131 64.4713L471.331 64.4713L471.331 55.4713L467.131 55.4713L467.131 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.691 64.4713L465.891 64.4713L465.891 55.4713L461.691 55.4713L461.691 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.25 64.4713L460.45 64.4713L460.45 55.4713L456.25 55.4713L456.25 64.4713Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 64.4713L498.471 64.4713L498.471 55.4713L494.271 55.4713L494.271 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 64.4713L493.03 64.4713L493.03 55.4713L488.83 55.4713L488.83 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 64.4713L487.59 64.4713L487.59 55.4713L483.39 55.4713L483.39 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 64.4713L482.149 64.4713L482.149 55.4713L477.949 55.4713L477.949 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 64.4713L476.608 64.4713L476.608 55.4713L472.408 55.4713L472.408 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 64.4713L471.168 64.4713L471.168 55.4713L466.968 55.4713L466.968 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 64.4713L465.728 64.4713L465.728 55.4713L461.528 55.4713L461.528 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 64.4713L460.188 64.4713L460.188 55.4713L455.988 55.4713L455.988 64.4713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 65.2975L498.471 65.2975L498.471 64.4975L494.271 64.4975L494.271 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 65.2975L493.03 65.2975L493.03 64.4975L488.83 64.4975L488.83 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 65.2975L487.59 65.2975L487.59 64.4975L483.39 64.4975L483.39 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 65.2975L482.149 65.2975L482.149 64.4975L477.949 64.4975L477.949 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 65.2975L476.608 65.2975L476.608 64.4975L472.408 64.4975L472.408 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 65.2975L471.168 65.2975L471.168 64.4975L466.968 64.4975L466.968 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 65.2975L465.728 65.2975L465.728 64.4975L461.528 64.4975L461.528 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 65.2975L460.188 65.2975L460.188 64.4975L455.988 64.4975L455.988 65.2975Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.779 65.2975L498.979 65.2975L498.979 64.4975L494.779 64.4975L494.779 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.338 65.2975L493.538 65.2975L493.538 64.4975L489.338 64.4975L489.338 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.797 65.2975L487.997 65.2975L487.997 64.4975L483.797 64.4975L483.797 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.357 65.2975L482.557 65.2975L482.557 64.4975L478.357 64.4975L478.357 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.916 65.2975L477.116 65.2975L477.116 64.4975L472.916 64.4975L472.916 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.376 65.2975L471.576 65.2975L471.576 64.4975L467.376 64.4975L467.376 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.936 65.2975L466.136 65.2975L466.136 64.4975L461.936 64.4975L461.936 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.495 65.2975L460.695 65.2975L460.695 64.4975L456.495 64.4975L456.495 65.2975Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.056 58.2367L460.256 58.2367L460.256 55.5367L456.056 55.5367L456.056 58.2367Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.578 61.339L465.778 61.339L465.778 55.539L461.578 55.539L461.578 61.339Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.03 60.8062L471.23 60.8062L471.23 55.5061L467.03 55.5061L467.03 60.8062Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.471 58.4294L476.671 58.4294L476.671 55.5294L472.471 55.5294L472.471 58.4294Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.011 57.4672L482.211 57.4672L482.211 55.5672L478.011 55.5672L478.011 57.4672Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.451 56.3304L487.651 56.3304L487.651 55.5304L483.451 55.5304L483.451 56.3304Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.892 58.2367L493.092 58.2367L493.092 55.5367L488.892 55.5367L488.892 58.2367Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.332 62.2803L498.532 62.2803L498.532 55.4803L494.332 55.4803L494.332 62.2803Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.601 52.8H441.601V67.3001H449.601V52.8Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 64.2001H443.9V65.0001H446.4V64.2001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 65.2001H442.5V66.0001H445V65.2001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.7 65.2001H445.2V66.0001H447.7V65.2001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 52.7781L502.194 52.7781L502.194 52.0781L449.594 52.0781L449.594 52.7781Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 52.1475L502.194 52.1475L502.194 51.4475L449.594 51.4475L449.594 52.1475Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 52.1H441.2V52.8H449.6V52.1Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 51.4H441.2V52.1H449.6V51.4Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.6 51.4H441.2V52.7H449.6V51.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.648 83.2075L501.348 83.2075L501.348 68.7075L449.648 68.7075L449.648 83.2075Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.533 80.4075L498.733 80.4075L498.733 71.4075L494.533 71.4075L494.533 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.992 80.4075L493.192 80.4075L493.192 71.4075L488.992 71.4075L488.992 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.552 80.4075L487.752 80.4075L487.752 71.4075L483.552 71.4075L483.552 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.112 80.4075L482.312 80.4075L482.312 71.4075L478.112 71.4075L478.112 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.572 80.4075L476.771 80.4075L476.771 71.4075L472.572 71.4075L472.572 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.131 80.4075L471.331 80.4075L471.331 71.4075L467.131 71.4075L467.131 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.691 80.4075L465.891 80.4075L465.891 71.4075L461.691 71.4075L461.691 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.25 80.4075L460.45 80.4075L460.45 71.4075L456.25 71.4075L456.25 80.4075Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 80.4075L498.471 80.4075L498.471 71.4075L494.271 71.4075L494.271 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 80.4075L493.03 80.4075L493.03 71.4075L488.83 71.4075L488.83 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 80.4075L487.59 80.4075L487.59 71.4075L483.39 71.4075L483.39 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 80.4075L482.149 80.4075L482.149 71.4075L477.949 71.4075L477.949 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 80.4075L476.608 80.4075L476.608 71.4075L472.408 71.4075L472.408 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 80.4075L471.168 80.4075L471.168 71.4075L466.968 71.4075L466.968 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 80.4075L465.728 80.4075L465.728 71.4075L461.528 71.4075L461.528 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 80.4075L460.188 80.4075L460.188 71.4075L455.988 71.4075L455.988 80.4075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 81.1338L498.471 81.1338L498.471 80.3338L494.271 80.3338L494.271 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 81.1338L493.03 81.1338L493.03 80.3338L488.83 80.3338L488.83 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 81.1338L487.59 81.1338L487.59 80.3338L483.39 80.3338L483.39 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 81.1338L482.149 81.1338L482.149 80.3338L477.949 80.3338L477.949 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 81.1338L476.608 81.1338L476.608 80.3338L472.408 80.3338L472.408 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 81.1338L471.168 81.1338L471.168 80.3338L466.968 80.3338L466.968 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 81.1338L465.728 81.1338L465.728 80.3338L461.528 80.3338L461.528 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 81.1338L460.188 81.1338L460.188 80.3338L455.988 80.3338L455.988 81.1338Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.779 81.1338L498.979 81.1338L498.979 80.3338L494.779 80.3338L494.779 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.338 81.1338L493.538 81.1338L493.538 80.3338L489.338 80.3338L489.338 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.797 81.1338L487.997 81.1338L487.997 80.3338L483.797 80.3338L483.797 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.357 81.1338L482.557 81.1338L482.557 80.3338L478.357 80.3338L478.357 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.916 81.1338L477.116 81.1338L477.116 80.3338L472.916 80.3338L472.916 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.376 81.1338L471.576 81.1338L471.576 80.3338L467.376 80.3338L467.376 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.936 81.1338L466.136 81.1338L466.136 80.3338L461.936 80.3338L461.936 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.495 81.1338L460.695 81.1338L460.695 80.3338L456.495 80.3338L456.495 81.1338Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.056 72.8146L460.256 72.8146L460.256 71.4146L456.056 71.4146L456.056 72.8146Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.578 72.4298L465.778 72.4298L465.778 71.4298L461.578 71.4298L461.578 72.4298Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.03 72.8146L471.23 72.8146L471.23 71.4146L467.03 71.4146L467.03 72.8146Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.471 72.911L476.671 72.911L476.671 71.411L472.471 71.411L472.471 72.911Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.011 72.4298L482.211 72.4298L482.211 71.4298L478.011 71.4298L478.011 72.4298Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.451 72.2667L487.651 72.2667L487.651 71.4667L483.451 71.4667L483.451 72.2667Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 72.7371L493.03 72.7371L493.03 71.3371L488.83 71.3371L488.83 72.7371Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.332 72.7317L498.532 72.7317L498.532 71.4317L494.332 71.4317L494.332 72.7317Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.601 68.6H441.601V83.1H449.601V68.6Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 80H443.9V80.8H446.4V80Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 81.1H442.5V81.9H445V81.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 68.6144L502.194 68.6144L502.194 67.9144L449.594 67.9144L449.594 68.6144Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 67.9838L502.194 67.9838L502.194 67.2838L449.594 67.2838L449.594 67.9838Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 68H441.2V68.7H449.6V68Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 67.3H441.2V68H449.6V67.3Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.6 67.3H441.2V68.6H449.6V67.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.648 99.0437L501.348 99.0437L501.348 84.5437L449.648 84.5437L449.648 99.0437Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.533 96.2437L498.733 96.2437L498.733 87.2437L494.533 87.2437L494.533 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.992 96.2437L493.192 96.2437L493.192 87.2437L488.992 87.2437L488.992 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.552 96.2437L487.752 96.2437L487.752 87.2437L483.552 87.2437L483.552 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.112 96.2437L482.312 96.2437L482.312 87.2437L478.112 87.2437L478.112 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.572 96.2437L476.771 96.2437L476.771 87.2437L472.572 87.2437L472.572 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.131 96.2437L471.331 96.2437L471.331 87.2437L467.131 87.2437L467.131 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.691 96.2437L465.891 96.2437L465.891 87.2437L461.691 87.2437L461.691 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.25 96.2437L460.45 96.2437L460.45 87.2437L456.25 87.2437L456.25 96.2437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 96.2437L498.471 96.2437L498.471 87.2437L494.271 87.2437L494.271 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 96.2437L493.03 96.2437L493.03 87.2437L488.83 87.2437L488.83 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 96.2437L487.59 96.2437L487.59 87.2437L483.39 87.2437L483.39 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 96.2437L482.149 96.2437L482.149 87.2437L477.949 87.2437L477.949 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 96.2437L476.608 96.2437L476.608 87.2437L472.408 87.2437L472.408 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 96.2437L471.168 96.2437L471.168 87.2437L466.968 87.2437L466.968 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 96.2437L465.728 96.2437L465.728 87.2437L461.528 87.2437L461.528 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 96.2437L460.188 96.2437L460.188 87.2437L455.988 87.2437L455.988 96.2437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 97.0699L498.471 97.0699L498.471 96.2699L494.271 96.2699L494.271 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 97.0699L493.03 97.0699L493.03 96.2699L488.83 96.2699L488.83 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 97.0699L487.59 97.0699L487.59 96.2699L483.39 96.2699L483.39 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 97.0699L482.149 97.0699L482.149 96.2699L477.949 96.2699L477.949 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 97.0699L476.608 97.0699L476.608 96.2699L472.408 96.2699L472.408 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 97.0699L471.168 97.0699L471.168 96.2699L466.968 96.2699L466.968 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 97.0699L465.728 97.0699L465.728 96.2699L461.528 96.2699L461.528 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 97.0699L460.188 97.0699L460.188 96.2699L455.988 96.2699L455.988 97.0699Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.779 97.0699L498.979 97.0699L498.979 96.2699L494.779 96.2699L494.779 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.338 97.0699L493.538 97.0699L493.538 96.2699L489.338 96.2699L489.338 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.797 97.0699L487.997 97.0699L487.997 96.2699L483.797 96.2699L483.797 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.357 97.0699L482.557 97.0699L482.557 96.2699L478.357 96.2699L478.357 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.916 97.0699L477.116 97.0699L477.116 96.2699L472.916 96.2699L472.916 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.376 97.0699L471.576 97.0699L471.576 96.2699L467.376 96.2699L467.376 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.936 97.0699L466.136 97.0699L466.136 96.2699L461.936 96.2699L461.936 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.495 97.0699L460.695 97.0699L460.695 96.2699L456.495 96.2699L456.495 97.0699Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.056 90.6378L460.256 90.6378L460.256 87.3378L456.056 87.3378L456.056 90.6378Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.578 89.0393L465.778 89.0393L465.778 87.3393L461.578 87.3393L461.578 89.0393Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.03 90.1405L471.23 90.1405L471.23 87.3405L467.03 87.3405L467.03 90.1405Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.471 90.7443L476.671 90.7443L476.671 87.2443L472.471 87.2443L472.471 90.7443Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.011 89.8917L482.211 89.8917L482.211 87.2917L478.011 87.2917L478.011 89.8917Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.451 89.2524L487.651 89.2524L487.651 87.2524L483.451 87.2524L483.451 89.2524Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.892 88.2725L493.092 88.2725L493.092 87.2725L488.892 87.2725L488.892 88.2725Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.332 88.5922L498.532 88.5922L498.532 87.2922L494.332 87.2922L494.332 88.5922Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.601 84.5H441.601V99H449.601V84.5Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 96.9H442.5V97.7H445V96.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.7 96.9H445.2V97.7H447.7V96.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 84.5505L502.194 84.5505L502.194 83.8505L449.594 83.8505L449.594 84.5505Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 83.8199L502.194 83.8199L502.194 83.1199L449.594 83.1199L449.594 83.8199Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 83.8H441.2V84.5H449.6V83.8Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 83.2H441.2V83.9H449.6V83.2Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.6 83.2H441.2V84.5H449.6V83.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.648 114.88L501.348 114.88L501.348 100.38L449.648 100.38L449.648 114.88Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.533 112.08L498.733 112.08L498.733 103.08L494.533 103.08L494.533 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.992 112.08L493.192 112.08L493.192 103.08L488.992 103.08L488.992 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.552 112.08L487.752 112.08L487.752 103.08L483.552 103.08L483.552 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.112 112.08L482.312 112.08L482.312 103.08L478.112 103.08L478.112 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.572 112.08L476.771 112.08L476.771 103.08L472.572 103.08L472.572 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.131 112.08L471.331 112.08L471.331 103.08L467.131 103.08L467.131 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.691 112.08L465.891 112.08L465.891 103.08L461.691 103.08L461.691 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.25 112.08L460.45 112.08L460.45 103.08L456.25 103.08L456.25 112.08Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 112.08L498.471 112.08L498.471 103.08L494.271 103.08L494.271 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 112.08L493.03 112.08L493.03 103.08L488.83 103.08L488.83 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 112.08L487.59 112.08L487.59 103.08L483.39 103.08L483.39 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 112.08L482.149 112.08L482.149 103.08L477.949 103.08L477.949 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 112.08L476.608 112.08L476.608 103.08L472.408 103.08L472.408 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 112.08L471.168 112.08L471.168 103.08L466.968 103.08L466.968 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 112.08L465.728 112.08L465.728 103.08L461.528 103.08L461.528 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 112.08L460.188 112.08L460.188 103.08L455.988 103.08L455.988 112.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.271 112.906L498.471 112.906L498.471 112.106L494.271 112.106L494.271 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.83 112.906L493.03 112.906L493.03 112.106L488.83 112.106L488.83 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39 112.906L487.59 112.906L487.59 112.106L483.39 112.106L483.39 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.949 112.906L482.149 112.906L482.149 112.106L477.949 112.106L477.949 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.408 112.906L476.608 112.906L476.608 112.106L472.408 112.106L472.408 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.968 112.906L471.168 112.906L471.168 112.106L466.968 112.106L466.968 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.528 112.906L465.728 112.906L465.728 112.106L461.528 112.106L461.528 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.988 112.906L460.188 112.906L460.188 112.106L455.988 112.106L455.988 112.906Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.779 112.906L498.979 112.906L498.979 112.106L494.779 112.106L494.779 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.338 112.906L493.538 112.906L493.538 112.106L489.338 112.106L489.338 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.797 112.906L487.997 112.906L487.997 112.106L483.797 112.106L483.797 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.357 112.906L482.557 112.906L482.557 112.106L478.357 112.106L478.357 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.916 112.906L477.116 112.906L477.116 112.106L472.916 112.106L472.916 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.376 112.906L471.576 112.906L471.576 112.106L467.376 112.106L467.376 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.936 112.906L466.136 112.906L466.136 112.106L461.936 112.106L461.936 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.495 112.906L460.695 112.906L460.695 112.106L456.495 112.106L456.495 112.906Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.056 105.845L460.256 105.845L460.256 103.145L456.056 103.145L456.056 105.845Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.578 108.948L465.778 108.948L465.778 103.148L461.578 103.148L461.578 108.948Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.03 108.415L471.23 108.415L471.23 103.115L467.03 103.115L467.03 108.415Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.471 106.038L476.671 106.038L476.671 103.138L472.471 103.138L472.471 106.038Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.011 105.076L482.211 105.076L482.211 103.176L478.011 103.176L478.011 105.076Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.451 103.939L487.651 103.939L487.651 103.139L483.451 103.139L483.451 103.939Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.892 105.845L493.092 105.845L493.092 103.145L488.892 103.145L488.892 105.845Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.332 109.889L498.532 109.889L498.532 103.089L494.332 103.089L494.332 109.889Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.601 100.4H441.601V114.9H449.601V100.4Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.4 111.8H443.9V112.6H446.4V111.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445 112.8H442.5V113.6H445V112.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.7 112.8H445.2V113.6H447.7V112.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 100.387L502.194 100.387L502.194 99.6867L449.594 99.6867L449.594 100.387Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.594 99.7561L502.194 99.7561L502.194 99.0561L449.594 99.0561L449.594 99.7561Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 99.7H441.2V100.4H449.6V99.7Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6 99H441.2V99.7H449.6V99Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.6 99H441.2V100.3H449.6V99Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.897 100.325L246.597 100.325L246.597 85.8248L194.897 85.8248L194.897 100.325Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.782 97.5248L243.982 97.5248L243.982 88.5248L239.782 88.5248L239.782 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.342 97.5248L238.542 97.5248L238.542 88.5248L234.342 88.5248L234.342 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.801 97.5248L233.001 97.5248L233.001 88.5248L228.801 88.5248L228.801 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.361 97.5248L227.561 97.5248L227.561 88.5248L223.361 88.5248L223.361 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 97.5248L222.12 97.5248L222.12 88.5248L217.92 88.5248L217.92 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38 97.5248L216.58 97.5248L216.58 88.5248L212.38 88.5248L212.38 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94 97.5248L211.14 97.5248L211.14 88.5248L206.94 88.5248L206.94 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.499 97.5248L205.699 97.5248L205.699 88.5248L201.499 88.5248L201.499 97.5248Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 97.5248L243.819 97.5248L243.819 88.5248L239.619 88.5248L239.619 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 97.5248L238.278 97.5248L238.278 88.5248L234.078 88.5248L234.078 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 97.5248L232.838 97.5248L232.838 88.5248L228.638 88.5248L228.638 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 97.5248L227.397 97.5248L227.397 88.5248L223.197 88.5248L223.197 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 97.5248L221.857 97.5248L221.857 88.5248L217.657 88.5248L217.657 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 97.5248L216.417 97.5248L216.417 88.5248L212.217 88.5248L212.217 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 97.5248L210.977 97.5248L210.977 88.5248L206.777 88.5248L206.777 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 97.5248L205.536 97.5248L205.536 88.5248L201.336 88.5248L201.336 97.5248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 98.3511L243.819 98.3511L243.819 97.5511L239.619 97.5511L239.619 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 98.3511L238.278 98.3511L238.278 97.5511L234.078 97.5511L234.078 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 98.3511L232.838 98.3511L232.838 97.5511L228.638 97.5511L228.638 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 98.3511L227.397 98.3511L227.397 97.5511L223.197 97.5511L223.197 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 98.3511L221.857 98.3511L221.857 97.5511L217.657 97.5511L217.657 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 98.3511L216.417 98.3511L216.417 97.5511L212.217 97.5511L212.217 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 98.3511L210.977 98.3511L210.977 97.5511L206.777 97.5511L206.777 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 98.3511L205.536 98.3511L205.536 97.5511L201.336 97.5511L201.336 98.3511Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.027 98.3511L244.227 98.3511L244.227 97.5511L240.027 97.5511L240.027 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.586 98.3511L238.786 98.3511L238.786 97.5511L234.586 97.5511L234.586 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.146 98.3511L233.346 98.3511L233.346 97.5511L229.146 97.5511L229.146 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.605 98.3511L227.805 98.3511L227.805 97.5511L223.605 97.5511L223.605 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.164 98.3511L222.364 98.3511L222.364 97.5511L218.164 97.5511L218.164 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.724 98.3511L216.924 98.3511L216.924 97.5511L212.724 97.5511L212.724 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.184 98.3511L211.384 98.3511L211.384 97.5511L207.184 97.5511L207.184 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.743 98.3511L205.943 98.3511L205.943 97.5511L201.743 97.5511L201.743 98.3511Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.404 91.2903L205.604 91.2903L205.604 88.5903L201.404 88.5903L201.404 91.2903Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.826 94.3925L211.026 94.3925L211.026 88.5925L206.826 88.5925L206.826 94.3925Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.279 93.8596L216.479 93.8596L216.479 88.5596L212.279 88.5596L212.279 93.8596Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82 91.483L222.02 91.483L222.02 88.583L217.82 88.583L217.82 91.483Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 90.5206L227.46 90.5206L227.46 88.6206L223.26 88.6206L223.26 90.5206Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 89.384L232.9 89.384L232.9 88.584L228.7 88.584L228.7 89.384Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.141 91.2903L238.341 91.2903L238.341 88.5903L234.141 88.5903L234.141 91.2903Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.681 95.3337L243.881 95.3337L243.881 88.5337L239.681 88.5337L239.681 95.3337Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9 85.7999H186.9V100.3H194.9V85.7999Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7 97.2H189.2V98H191.7V97.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.301 98.2H187.801V99H190.301V98.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 98.2H190.5V99H193V98.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 85.8317L247.443 85.8317L247.443 85.1317L194.843 85.1317L194.843 85.8317Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 85.1011L247.443 85.1011L247.443 84.4011L194.843 84.4011L194.843 85.1011Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 85.1H186.4V85.8H194.8V85.1Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 84.4999H186.4V85.1999H194.8V84.4999Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8 84.4999H186.4V85.7999H194.8V84.4999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.897 116.161L246.597 116.161L246.597 101.661L194.897 101.661L194.897 116.161Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.782 113.361L243.982 113.361L243.982 104.361L239.782 104.361L239.782 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.342 113.361L238.542 113.361L238.542 104.361L234.342 104.361L234.342 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.801 113.361L233.001 113.361L233.001 104.361L228.801 104.361L228.801 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.361 113.361L227.561 113.361L227.561 104.361L223.361 104.361L223.361 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 113.361L222.12 113.361L222.12 104.361L217.92 104.361L217.92 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38 113.361L216.58 113.361L216.58 104.361L212.38 104.361L212.38 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94 113.361L211.14 113.361L211.14 104.361L206.94 104.361L206.94 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.499 113.361L205.699 113.361L205.699 104.361L201.499 104.361L201.499 113.361Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 113.361L243.819 113.361L243.819 104.361L239.619 104.361L239.619 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 113.361L238.278 113.361L238.278 104.361L234.078 104.361L234.078 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 113.361L232.838 113.361L232.838 104.361L228.638 104.361L228.638 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 113.361L227.397 113.361L227.397 104.361L223.197 104.361L223.197 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 113.361L221.857 113.361L221.857 104.361L217.657 104.361L217.657 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 113.361L216.417 113.361L216.417 104.361L212.217 104.361L212.217 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 113.361L210.977 113.361L210.977 104.361L206.777 104.361L206.777 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 113.361L205.536 113.361L205.536 104.361L201.336 104.361L201.336 113.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 114.187L243.819 114.187L243.819 113.387L239.619 113.387L239.619 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 114.187L238.278 114.187L238.278 113.387L234.078 113.387L234.078 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 114.187L232.838 114.187L232.838 113.387L228.638 113.387L228.638 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 114.187L227.397 114.187L227.397 113.387L223.197 113.387L223.197 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 114.187L221.857 114.187L221.857 113.387L217.657 113.387L217.657 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 114.187L216.417 114.187L216.417 113.387L212.217 113.387L212.217 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 114.187L210.977 114.187L210.977 113.387L206.777 113.387L206.777 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 114.187L205.536 114.187L205.536 113.387L201.336 113.387L201.336 114.187Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.027 114.187L244.227 114.187L244.227 113.387L240.027 113.387L240.027 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.586 114.187L238.786 114.187L238.786 113.387L234.586 113.387L234.586 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.146 114.187L233.346 114.187L233.346 113.387L229.146 113.387L229.146 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.605 114.187L227.805 114.187L227.805 113.387L223.605 113.387L223.605 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.164 114.187L222.364 114.187L222.364 113.387L218.164 113.387L218.164 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.724 114.187L216.924 114.187L216.924 113.387L212.724 113.387L212.724 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.184 114.187L211.384 114.187L211.384 113.387L207.184 113.387L207.184 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.743 114.187L205.943 114.187L205.943 113.387L201.743 113.387L201.743 114.187Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.404 105.768L205.604 105.768L205.604 104.368L201.404 104.368L201.404 105.768Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.826 105.383L211.026 105.383L211.026 104.383L206.826 104.383L206.826 105.383Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.279 105.768L216.479 105.768L216.479 104.368L212.279 104.368L212.279 105.768Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82 105.865L222.02 105.865L222.02 104.365L217.82 104.365L217.82 105.865Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 105.383L227.46 105.383L227.46 104.383L223.26 104.383L223.26 105.383Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 105.22L232.9 105.22L232.9 104.42L228.7 104.42L228.7 105.22Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.179 105.791L238.379 105.791L238.379 104.391L234.179 104.391L234.179 105.791Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.681 105.685L243.881 105.685L243.881 104.385L239.681 104.385L239.681 105.685Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9 101.7H186.9V116.2H194.9V101.7Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7 113.1H189.2V113.9H191.7V113.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.301 114.1H187.801V114.9H190.301V114.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 101.668L247.443 101.668L247.443 100.968L194.843 100.968L194.843 101.668Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 101.037L247.443 101.037L247.443 100.337L194.843 100.337L194.843 101.037Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 101H186.4V101.7H194.8V101Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 100.3H186.4V101H194.8V100.3Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8 100.3H186.4V101.6H194.8V100.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.897 132.097L246.597 132.097L246.597 117.597L194.897 117.597L194.897 132.097Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.782 129.297L243.982 129.297L243.982 120.297L239.782 120.297L239.782 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.342 129.297L238.542 129.297L238.542 120.297L234.342 120.297L234.342 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.801 129.297L233.001 129.297L233.001 120.297L228.801 120.297L228.801 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.361 129.297L227.561 129.297L227.561 120.297L223.361 120.297L223.361 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 129.297L222.12 129.297L222.12 120.297L217.92 120.297L217.92 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38 129.297L216.58 129.297L216.58 120.297L212.38 120.297L212.38 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94 129.297L211.14 129.297L211.14 120.297L206.94 120.297L206.94 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.499 129.297L205.699 129.297L205.699 120.297L201.499 120.297L201.499 129.297Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 129.297L243.819 129.297L243.819 120.297L239.619 120.297L239.619 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 129.297L238.278 129.297L238.278 120.297L234.078 120.297L234.078 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 129.297L232.838 129.297L232.838 120.297L228.638 120.297L228.638 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 129.297L227.397 129.297L227.397 120.297L223.197 120.297L223.197 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 129.297L221.857 129.297L221.857 120.297L217.657 120.297L217.657 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 129.297L216.417 129.297L216.417 120.297L212.217 120.297L212.217 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 129.297L210.977 129.297L210.977 120.297L206.777 120.297L206.777 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 129.297L205.536 129.297L205.536 120.297L201.336 120.297L201.336 129.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 130.024L243.819 130.024L243.819 129.224L239.619 129.224L239.619 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 130.024L238.278 130.024L238.278 129.224L234.078 129.224L234.078 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 130.024L232.838 130.024L232.838 129.224L228.638 129.224L228.638 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 130.024L227.397 130.024L227.397 129.224L223.197 129.224L223.197 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 130.024L221.857 130.024L221.857 129.224L217.657 129.224L217.657 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 130.024L216.417 130.024L216.417 129.224L212.217 129.224L212.217 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 130.024L210.977 130.024L210.977 129.224L206.777 129.224L206.777 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 130.024L205.536 130.024L205.536 129.224L201.336 129.224L201.336 130.024Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.027 130.024L244.227 130.024L244.227 129.224L240.027 129.224L240.027 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.586 130.024L238.786 130.024L238.786 129.224L234.586 129.224L234.586 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.146 130.024L233.346 130.024L233.346 129.224L229.146 129.224L229.146 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.605 130.024L227.805 130.024L227.805 129.224L223.605 129.224L223.605 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.164 130.024L222.364 130.024L222.364 129.224L218.164 129.224L218.164 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.724 130.024L216.924 130.024L216.924 129.224L212.724 129.224L212.724 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.184 130.024L211.384 130.024L211.384 129.224L207.184 129.224L207.184 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.743 130.024L205.943 130.024L205.943 129.224L201.743 129.224L201.743 130.024Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.404 123.691L205.604 123.691L205.604 120.391L201.404 120.391L201.404 123.691Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.826 122.093L211.026 122.093L211.026 120.393L206.826 120.393L206.826 122.093Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.279 123.194L216.479 123.194L216.479 120.394L212.279 120.394L212.279 123.194Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82 123.798L222.02 123.798L222.02 120.298L217.82 120.298L217.82 123.798Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 122.945L227.46 122.945L227.46 120.345L223.26 120.345L223.26 122.945Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 122.306L232.9 122.306L232.9 120.306L228.7 120.306L228.7 122.306Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.141 121.326L238.341 121.326L238.341 120.326L234.141 120.326L234.141 121.326Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.681 121.646L243.881 121.646L243.881 120.346L239.681 120.346L239.681 121.646Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9 117.5H186.9V132H194.9V117.5Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.301 130H187.801V130.8H190.301V130Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 130H190.5V130.8H193V130Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 117.504L247.443 117.504L247.443 116.804L194.843 116.804L194.843 117.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 116.874L247.443 116.874L247.443 116.174L194.843 116.174L194.843 116.874Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 116.9H186.4V117.6H194.8V116.9Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 116.2H186.4V116.9H194.8V116.2Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8 116.2H186.4V117.5H194.8V116.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.897 147.934L246.597 147.934L246.597 133.434L194.897 133.434L194.897 147.934Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.782 145.134L243.982 145.134L243.982 136.134L239.782 136.134L239.782 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.342 145.134L238.542 145.134L238.542 136.134L234.342 136.134L234.342 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.801 145.134L233.001 145.134L233.001 136.134L228.801 136.134L228.801 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.361 145.134L227.561 145.134L227.561 136.134L223.361 136.134L223.361 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.92 145.134L222.12 145.134L222.12 136.134L217.92 136.134L217.92 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.38 145.134L216.58 145.134L216.58 136.134L212.38 136.134L212.38 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.94 145.134L211.14 145.134L211.14 136.134L206.94 136.134L206.94 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.499 145.134L205.699 145.134L205.699 136.134L201.499 136.134L201.499 145.134Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 145.134L243.819 145.134L243.819 136.134L239.619 136.134L239.619 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 145.134L238.278 145.134L238.278 136.134L234.078 136.134L234.078 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 145.134L232.838 145.134L232.838 136.134L228.638 136.134L228.638 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 145.134L227.397 145.134L227.397 136.134L223.197 136.134L223.197 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 145.134L221.857 145.134L221.857 136.134L217.657 136.134L217.657 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 145.134L216.417 145.134L216.417 136.134L212.217 136.134L212.217 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 145.134L210.977 145.134L210.977 136.134L206.777 136.134L206.777 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 145.134L205.536 145.134L205.536 136.134L201.336 136.134L201.336 145.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.619 145.96L243.819 145.96L243.819 145.16L239.619 145.16L239.619 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.078 145.96L238.278 145.96L238.278 145.16L234.078 145.16L234.078 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.638 145.96L232.838 145.96L232.838 145.16L228.638 145.16L228.638 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.197 145.96L227.397 145.96L227.397 145.16L223.197 145.16L223.197 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.657 145.96L221.857 145.96L221.857 145.16L217.657 145.16L217.657 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.217 145.96L216.417 145.96L216.417 145.16L212.217 145.16L212.217 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.777 145.96L210.977 145.96L210.977 145.16L206.777 145.16L206.777 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.336 145.96L205.536 145.96L205.536 145.16L201.336 145.16L201.336 145.96Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.027 145.96L244.227 145.96L244.227 145.16L240.027 145.16L240.027 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.586 145.96L238.786 145.96L238.786 145.16L234.586 145.16L234.586 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.146 145.96L233.346 145.96L233.346 145.16L229.146 145.16L229.146 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.605 145.96L227.805 145.96L227.805 145.16L223.605 145.16L223.605 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.164 145.96L222.364 145.96L222.364 145.16L218.164 145.16L218.164 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.724 145.96L216.924 145.96L216.924 145.16L212.724 145.16L212.724 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.184 145.96L211.384 145.96L211.384 145.16L207.184 145.16L207.184 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.743 145.96L205.943 145.96L205.943 145.16L201.743 145.16L201.743 145.96Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.404 138.899L205.604 138.899L205.604 136.199L201.404 136.199L201.404 138.899Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.826 142.001L211.026 142.001L211.026 136.201L206.826 136.201L206.826 142.001Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.279 141.468L216.479 141.468L216.479 136.168L212.279 136.168L212.279 141.468Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.82 139.092L222.02 139.092L222.02 136.192L217.82 136.192L217.82 139.092Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 138.129L227.46 138.129L227.46 136.229L223.26 136.229L223.26 138.129Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.7 136.993L232.9 136.993L232.9 136.193L228.7 136.193L228.7 136.993Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.141 138.899L238.341 138.899L238.341 136.199L234.141 136.199L234.141 138.899Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.681 142.943L243.881 142.943L243.881 136.143L239.681 136.143L239.681 142.943Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.9 133.4H186.9V147.9H194.9V133.4Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.7 144.8H189.2V145.6H191.7V144.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.301 145.8H187.801V146.6H190.301V145.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 145.8H190.5V146.6H193V145.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 133.44L247.443 133.44L247.443 132.74L194.843 132.74L194.843 133.44Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.843 132.71L247.443 132.71L247.443 132.01L194.843 132.01L194.843 132.71Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 132.7H186.4V133.4H194.8V132.7Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.8 132.1H186.4V132.8H194.8V132.1Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8 132.1H186.4V133.4H194.8V132.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.962 92.426L323.162 92.426L323.162 83.626L291.962 83.626L291.962 92.426Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.047 90.726L321.547 90.726L321.547 85.326L319.047 85.326L319.047 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.754 90.726L318.254 90.726L318.254 85.326L315.754 85.326L315.754 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46 90.726L314.96 90.726L314.96 85.326L312.46 85.326L312.46 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.166 90.726L311.666 90.726L311.666 85.326L309.166 85.326L309.166 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.872 90.726L308.372 90.726L308.372 85.326L305.872 85.326L305.872 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.578 90.726L305.078 90.726L305.078 85.326L302.578 85.326L302.578 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.285 90.726L301.785 90.726L301.785 85.326L299.285 85.326L299.285 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.991 90.726L298.491 90.726L298.491 85.326L295.991 85.326L295.991 90.726Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 90.726L321.429 90.726L321.429 85.326L318.929 85.326L318.929 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 90.726L318.135 90.726L318.135 85.326L315.635 85.326L315.635 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 90.726L314.841 90.726L314.841 85.326L312.341 85.326L312.341 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 90.726L311.547 90.726L311.547 85.326L309.047 85.326L309.047 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 90.726L308.253 90.726L308.253 85.326L305.753 85.326L305.753 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 90.726L304.96 90.726L304.96 85.326L302.46 85.326L302.46 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 90.726L301.666 90.726L301.666 85.326L299.166 85.326L299.166 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 90.726L298.372 90.726L298.372 85.326L295.872 85.326L295.872 90.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 91.1879L321.429 91.1879L321.429 90.6879L318.929 90.6879L318.929 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 91.1879L318.135 91.1879L318.135 90.6879L315.635 90.6879L315.635 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 91.1879L314.841 91.1879L314.841 90.6879L312.341 90.6879L312.341 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 91.1879L311.547 91.1879L311.547 90.6879L309.047 90.6879L309.047 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 91.1879L308.253 91.1879L308.253 90.6879L305.753 90.6879L305.753 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 91.1879L304.96 91.1879L304.96 90.6879L302.46 90.6879L302.46 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 91.1879L301.666 91.1879L301.666 90.6879L299.166 90.6879L299.166 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 91.1879L298.372 91.1879L298.372 90.6879L295.872 90.6879L295.872 91.1879Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.275 91.1879L321.775 91.1879L321.775 90.6879L319.275 90.6879L319.275 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.981 91.1879L318.481 91.1879L318.481 90.6879L315.981 90.6879L315.981 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.688 91.1879L315.188 91.1879L315.188 90.6879L312.688 90.6879L312.688 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.395 91.1879L311.895 91.1879L311.895 90.6879L309.395 90.6879L309.395 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.101 91.1879L308.601 91.1879L308.601 90.6879L306.101 90.6879L306.101 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.707 91.1879L305.207 91.1879L305.207 90.6879L302.707 90.6879L302.707 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.413 91.1879L301.913 91.1879L301.913 90.6879L299.413 90.6879L299.413 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 91.1879L298.619 91.1879L298.619 90.6879L296.119 90.6879L296.119 91.1879Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.913 86.9684L298.413 86.9684L298.413 85.3684L295.913 85.3684L295.913 86.9684Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.196 88.838L301.696 88.838L301.696 85.338L299.196 85.338L299.196 88.838Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.497 88.5168L304.997 88.5168L304.997 85.3168L302.497 85.3168L302.497 88.5168Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.791 87.0846L308.291 87.0846L308.291 85.2846L305.791 85.2846L305.791 87.0846Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.085 86.5045L311.585 86.5045L311.585 85.3045L309.085 85.3045L309.085 86.5045Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.379 85.8196L314.879 85.8196L314.879 85.3196L312.379 85.3196L312.379 85.8196Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 86.9684L318.172 86.9684L318.172 85.3684L315.672 85.3684L315.672 86.9684Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.966 89.4053L321.466 89.4053L321.466 85.3053L318.966 85.3053L318.966 89.4053Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 83.6001H287.2V92.4001H292V83.6001Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 90.5H288.5V91H290V90.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.2 91.1001H287.7V91.6001H289.2V91.1001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 91.1001H289.4V91.6001H290.9V91.1001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 83.6692L323.673 83.6692L323.673 83.2692L291.973 83.2692L291.973 83.6692Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 83.2672L323.673 83.2672L323.673 82.8672L291.973 82.8672L291.973 83.2672Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 83.2001H286.9V83.6001H292V83.2001Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 82.8H286.9V83.2H292V82.8Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 82.8H286.9V83.6H292V82.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.962 101.953L323.162 101.953L323.162 93.1531L291.962 93.1531L291.962 101.953Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.047 100.253L321.547 100.253L321.547 94.8532L319.047 94.8532L319.047 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.754 100.253L318.254 100.253L318.254 94.8532L315.754 94.8532L315.754 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46 100.253L314.96 100.253L314.96 94.8532L312.46 94.8532L312.46 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.166 100.253L311.666 100.253L311.666 94.8532L309.166 94.8532L309.166 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.872 100.253L308.372 100.253L308.372 94.8532L305.872 94.8532L305.872 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.578 100.253L305.078 100.253L305.078 94.8532L302.578 94.8532L302.578 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.285 100.253L301.785 100.253L301.785 94.8532L299.285 94.8532L299.285 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.991 100.253L298.491 100.253L298.491 94.8532L295.991 94.8532L295.991 100.253Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 100.253L321.429 100.253L321.429 94.8532L318.929 94.8532L318.929 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 100.253L318.135 100.253L318.135 94.8532L315.635 94.8532L315.635 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 100.253L314.841 100.253L314.841 94.8532L312.341 94.8532L312.341 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 100.253L311.547 100.253L311.547 94.8532L309.047 94.8532L309.047 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 100.253L308.253 100.253L308.253 94.8532L305.753 94.8532L305.753 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 100.253L304.96 100.253L304.96 94.8532L302.46 94.8532L302.46 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 100.253L301.666 100.253L301.666 94.8532L299.166 94.8532L299.166 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 100.253L298.372 100.253L298.372 94.8532L295.872 94.8532L295.872 100.253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 100.715L321.429 100.715L321.429 100.215L318.929 100.215L318.929 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 100.715L318.135 100.715L318.135 100.215L315.635 100.215L315.635 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 100.715L314.841 100.715L314.841 100.215L312.341 100.215L312.341 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 100.715L311.547 100.715L311.547 100.215L309.047 100.215L309.047 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 100.715L308.253 100.715L308.253 100.215L305.753 100.215L305.753 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 100.715L304.96 100.715L304.96 100.215L302.46 100.215L302.46 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 100.715L301.666 100.715L301.666 100.215L299.166 100.215L299.166 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 100.715L298.372 100.715L298.372 100.215L295.872 100.215L295.872 100.715Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.275 100.715L321.775 100.715L321.775 100.215L319.275 100.215L319.275 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.981 100.715L318.481 100.715L318.481 100.215L315.981 100.215L315.981 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.688 100.715L315.188 100.715L315.188 100.215L312.688 100.215L312.688 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.395 100.715L311.895 100.715L311.895 100.215L309.395 100.215L309.395 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.101 100.715L308.601 100.715L308.601 100.215L306.101 100.215L306.101 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.707 100.715L305.207 100.715L305.207 100.215L302.707 100.215L302.707 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.413 100.715L301.913 100.715L301.913 100.215L299.413 100.215L299.413 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 100.715L298.619 100.715L298.619 100.215L296.119 100.215L296.119 100.715Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.913 95.677L298.413 95.677L298.413 94.877L295.913 94.877L295.913 95.677Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.196 95.4449L301.696 95.4449L301.696 94.8449L299.196 94.8449L299.196 95.4449Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.497 95.677L304.997 95.677L304.997 94.877L302.497 94.877L302.497 95.677Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.791 95.735L308.291 95.735L308.291 94.835L305.791 94.835L305.791 95.735Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.085 95.4449L311.585 95.4449L311.585 94.8449L309.085 94.8449L309.085 95.4449Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.379 95.3467L314.879 95.3467L314.879 94.8467L312.379 94.8467L312.379 95.3467Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.734 95.6302L318.234 95.6302L318.234 94.8303L315.734 94.8303L315.734 95.6302Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.966 95.627L321.466 95.627L321.466 94.827L318.966 94.827L318.966 95.627Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 93.2H287.2V102H292V93.2Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 100.1H288.5V100.6H290V100.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.2 100.7H287.7V101.2H289.2V100.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 93.1963L323.673 93.1963L323.673 92.7963L291.973 92.7963L291.973 93.1963Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 92.7944L323.673 92.7944L323.673 92.3944L291.973 92.3944L291.973 92.7944Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 92.8H286.9V93.2H292V92.8Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 92.4H286.9V92.8H292V92.4Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 92.4H286.9V93.2H292V92.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.962 111.48L323.162 111.48L323.162 102.68L291.962 102.68L291.962 111.48Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.047 109.88L321.547 109.88L321.547 104.48L319.047 104.48L319.047 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.754 109.88L318.254 109.88L318.254 104.48L315.754 104.48L315.754 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46 109.88L314.96 109.88L314.96 104.48L312.46 104.48L312.46 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.166 109.88L311.666 109.88L311.666 104.48L309.166 104.48L309.166 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.872 109.88L308.372 109.88L308.372 104.48L305.872 104.48L305.872 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.578 109.88L305.078 109.88L305.078 104.48L302.578 104.48L302.578 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.285 109.88L301.785 109.88L301.785 104.48L299.285 104.48L299.285 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.991 109.88L298.491 109.88L298.491 104.48L295.991 104.48L295.991 109.88Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 109.88L321.429 109.88L321.429 104.48L318.929 104.48L318.929 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 109.88L318.135 109.88L318.135 104.48L315.635 104.48L315.635 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 109.88L314.841 109.88L314.841 104.48L312.341 104.48L312.341 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 109.88L311.547 109.88L311.547 104.48L309.047 104.48L309.047 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 109.88L308.253 109.88L308.253 104.48L305.753 104.48L305.753 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 109.88L304.96 109.88L304.96 104.48L302.46 104.48L302.46 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 109.88L301.666 109.88L301.666 104.48L299.166 104.48L299.166 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 109.88L298.372 109.88L298.372 104.48L295.872 104.48L295.872 109.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 110.342L321.429 110.342L321.429 109.842L318.929 109.842L318.929 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 110.342L318.135 110.342L318.135 109.842L315.635 109.842L315.635 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 110.342L314.841 110.342L314.841 109.842L312.341 109.842L312.341 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 110.342L311.547 110.342L311.547 109.842L309.047 109.842L309.047 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 110.342L308.253 110.342L308.253 109.842L305.753 109.842L305.753 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 110.342L304.96 110.342L304.96 109.842L302.46 109.842L302.46 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 110.342L301.666 110.342L301.666 109.842L299.166 109.842L299.166 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 110.342L298.372 110.342L298.372 109.842L295.872 109.842L295.872 110.342Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.275 110.342L321.775 110.342L321.775 109.842L319.275 109.842L319.275 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.981 110.342L318.481 110.342L318.481 109.842L315.981 109.842L315.981 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.688 110.342L315.188 110.342L315.188 109.842L312.688 109.842L312.688 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.395 110.342L311.895 110.342L311.895 109.842L309.395 109.842L309.395 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.101 110.342L308.601 110.342L308.601 109.842L306.101 109.842L306.101 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.707 110.342L305.207 110.342L305.207 109.842L302.707 109.842L302.707 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.413 110.342L301.913 110.342L301.913 109.842L299.413 109.842L299.413 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 110.342L298.619 110.342L298.619 109.842L296.119 109.842L296.119 110.342Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.913 106.502L298.413 106.502L298.413 104.502L295.913 104.502L295.913 106.502Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.196 105.538L301.696 105.538L301.696 104.438L299.196 104.438L299.196 105.538Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.497 106.202L304.997 106.202L304.997 104.502L302.497 104.502L302.497 106.202Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.791 106.566L308.291 106.566L308.291 104.466L305.791 104.466L305.791 106.566Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.085 106.052L311.585 106.052L311.585 104.452L309.085 104.452L309.085 106.052Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.379 105.667L314.879 105.667L314.879 104.467L312.379 104.467L312.379 105.667Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 105.076L318.172 105.076L318.172 104.476L315.672 104.476L315.672 105.076Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.966 105.269L321.466 105.269L321.466 104.469L318.966 104.469L318.966 105.269Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 102.8H287.2V111.6H292V102.8Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.2 110.2H287.7V110.7H289.2V110.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 110.2H289.4V110.7H290.9V110.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 102.724L323.673 102.724L323.673 102.324L291.973 102.324L291.973 102.724Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 102.322L323.673 102.322L323.673 101.922L291.973 101.922L291.973 102.322Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 102.4H286.9V102.8H292V102.4Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 102H286.9V102.4H292V102Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 102H286.9V102.8H292V102Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.962 121.108L323.162 121.108L323.162 112.308L291.962 112.308L291.962 121.108Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.047 119.408L321.547 119.408L321.547 114.008L319.047 114.008L319.047 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.754 119.408L318.254 119.408L318.254 114.008L315.754 114.008L315.754 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.46 119.408L314.96 119.408L314.96 114.008L312.46 114.008L312.46 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.166 119.408L311.666 119.408L311.666 114.008L309.166 114.008L309.166 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.872 119.408L308.372 119.408L308.372 114.008L305.872 114.008L305.872 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.578 119.408L305.078 119.408L305.078 114.008L302.578 114.008L302.578 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.285 119.408L301.785 119.408L301.785 114.008L299.285 114.008L299.285 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.991 119.408L298.491 119.408L298.491 114.008L295.991 114.008L295.991 119.408Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 119.408L321.429 119.408L321.429 114.008L318.929 114.008L318.929 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 119.408L318.135 119.408L318.135 114.008L315.635 114.008L315.635 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 119.408L314.841 119.408L314.841 114.008L312.341 114.008L312.341 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 119.408L311.547 119.408L311.547 114.008L309.047 114.008L309.047 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 119.408L308.253 119.408L308.253 114.008L305.753 114.008L305.753 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 119.408L304.96 119.408L304.96 114.008L302.46 114.008L302.46 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 119.408L301.666 119.408L301.666 114.008L299.166 114.008L299.166 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 119.408L298.372 119.408L298.372 114.008L295.872 114.008L295.872 119.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.929 119.87L321.429 119.87L321.429 119.37L318.929 119.37L318.929 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.635 119.87L318.135 119.87L318.135 119.37L315.635 119.37L315.635 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.341 119.87L314.841 119.87L314.841 119.37L312.341 119.37L312.341 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.047 119.87L311.547 119.87L311.547 119.37L309.047 119.37L309.047 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.753 119.87L308.253 119.87L308.253 119.37L305.753 119.37L305.753 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 119.87L304.96 119.87L304.96 119.37L302.46 119.37L302.46 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.166 119.87L301.666 119.87L301.666 119.37L299.166 119.37L299.166 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.872 119.87L298.372 119.87L298.372 119.37L295.872 119.37L295.872 119.87Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.275 119.87L321.775 119.87L321.775 119.37L319.275 119.37L319.275 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.981 119.87L318.481 119.87L318.481 119.37L315.981 119.37L315.981 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.688 119.87L315.188 119.87L315.188 119.37L312.688 119.37L312.688 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.395 119.87L311.895 119.87L311.895 119.37L309.395 119.37L309.395 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.101 119.87L308.601 119.87L308.601 119.37L306.101 119.37L306.101 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.707 119.87L305.207 119.87L305.207 119.37L302.707 119.37L302.707 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.413 119.87L301.913 119.87L301.913 119.37L299.413 119.37L299.413 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.119 119.87L298.619 119.87L298.619 119.37L296.119 119.37L296.119 119.87Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.913 115.65L298.413 115.65L298.413 114.05L295.913 114.05L295.913 115.65Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.196 117.52L301.696 117.52L301.696 114.02L299.196 114.02L299.196 117.52Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.497 117.199L304.997 117.199L304.997 113.999L302.497 113.999L302.497 117.199Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.791 115.766L308.291 115.766L308.291 113.966L305.791 113.966L305.791 115.766Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.085 115.186L311.585 115.186L311.585 113.986L309.085 113.986L309.085 115.186Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.379 114.501L314.879 114.501L314.879 114.001L312.379 114.001L312.379 114.501Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.672 115.65L318.172 115.65L318.172 114.05L315.672 114.05L315.672 115.65Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.966 118.087L321.466 118.087L321.466 113.987L318.966 113.987L318.966 118.087Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 112.3H287.2V121.1H292V112.3Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290 119.2H288.5V119.7H290V119.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.2 119.8H287.7V120.3H289.2V119.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.9 119.8H289.4V120.3H290.9V119.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 112.351L323.673 112.351L323.673 111.951L291.973 111.951L291.973 112.351Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.973 111.949L323.673 111.949L323.673 111.549L291.973 111.549L291.973 111.949Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 111.9H286.9V112.3H292V111.9Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 111.5H286.9V111.9H292V111.5Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292 111.5H286.9V112.3H292V111.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 92.3378L623.079 92.3378L623.079 73.1378L554.879 73.1378L554.879 92.3378Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 88.6379L619.618 88.6379L619.618 76.8379L614.118 76.8379L614.118 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 88.6379L612.396 88.6379L612.396 76.8379L606.896 76.8379L606.896 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 88.6379L605.176 88.6379L605.176 76.8379L599.676 76.8379L599.676 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 88.6379L597.954 88.6379L597.954 76.8379L592.454 76.8379L592.454 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 88.6379L590.733 88.6379L590.733 76.8379L585.233 76.8379L585.233 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 88.6379L583.512 88.6379L583.512 76.8379L578.012 76.8379L578.012 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 88.6379L576.291 88.6379L576.291 76.8379L570.791 76.8379L570.791 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 88.6379L569.17 88.6379L569.17 76.8379L563.67 76.8379L563.67 88.6379Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 88.6379L619.339 88.6379L619.339 76.8379L613.839 76.8379L613.839 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 88.6379L612.117 88.6379L612.117 76.8379L606.617 76.8379L606.617 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 88.6379L604.896 88.6379L604.896 76.8379L599.396 76.8379L599.396 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 88.6379L597.775 88.6379L597.775 76.8379L592.275 76.8379L592.275 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 88.6379L590.554 88.6379L590.554 76.8379L585.054 76.8379L585.054 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 88.6379L583.333 88.6379L583.333 76.8379L577.833 76.8379L577.833 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 88.6379L576.111 88.6379L576.111 76.8379L570.611 76.8379L570.611 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 88.6379L568.891 88.6379L568.891 76.8379L563.391 76.8379L563.391 88.6379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 89.6584L619.339 89.6584L619.339 88.6584L613.839 88.6584L613.839 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 89.6584L612.117 89.6584L612.117 88.6584L606.617 88.6584L606.617 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 89.6584L604.896 89.6584L604.896 88.6584L599.396 88.6584L599.396 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 89.6584L597.775 89.6584L597.775 88.6584L592.275 88.6584L592.275 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 89.6584L590.554 89.6584L590.554 88.6584L585.054 88.6584L585.054 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 89.6584L583.333 89.6584L583.333 88.6584L577.833 88.6584L577.833 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 89.6584L576.111 89.6584L576.111 88.6584L570.611 88.6584L570.611 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 89.6584L568.891 89.6584L568.891 88.6584L563.391 88.6584L563.391 89.6584Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 89.6584L619.936 89.6584L619.936 88.6584L614.436 88.6584L614.436 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 89.6584L612.714 89.6584L612.714 88.6584L607.214 88.6584L607.214 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 89.6584L605.493 89.6584L605.493 88.6584L599.993 88.6584L599.993 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 89.6584L598.372 89.6584L598.372 88.6584L592.872 88.6584L592.872 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 89.6584L591.15 89.6584L591.15 88.6584L585.65 88.6584L585.65 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 89.6584L583.93 89.6584L583.93 88.6584L578.43 88.6584L578.43 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 89.6584L576.709 89.6584L576.709 88.6584L571.209 88.6584L571.209 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 89.6584L569.487 89.6584L569.487 88.6584L563.987 88.6584L563.987 89.6584Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 80.4197L568.98 80.4197L568.98 76.8197L563.38 76.8197L563.38 80.4197Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 84.5088L576.178 84.5088L576.178 76.8088L570.578 76.8088L570.578 84.5088Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 83.8065L583.414 83.8065L583.414 76.8065L577.814 76.8065L577.814 83.8065Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 80.6738L590.636 80.6738L590.636 76.8738L585.036 76.8738L585.036 80.6738Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 79.4053L597.857 79.4053L597.857 76.8053L592.257 76.8053L592.257 79.4053Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 77.907L604.979 77.907L604.979 76.807L599.379 76.807L599.379 77.907Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.599 80.4197L612.199 80.4197L612.199 76.8197L606.599 76.8197L606.599 80.4197Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 85.7496L619.421 85.7496L619.421 76.8496L613.821 76.8496L613.821 85.7496Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 73.2001H544.4V92.4001H554.9V73.2001Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.7 88.2001H547.4V89.3001H550.7V88.2001Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 89.6H545.501V90.7H548.801V89.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.401 89.6H549.101V90.7H552.401V89.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 73.2111L624.195 73.2111L624.195 72.3111L554.895 72.3111L554.895 73.2111Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 72.3571L624.195 72.3571L624.195 71.4571L554.895 71.4571L554.895 72.3571Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 72.3H543.801V73.2H554.901V72.3Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 71.4H543.801V72.3H554.901V71.4Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 71.4H543.801V73.2H554.901V71.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 113.271L623.079 113.271L623.079 94.0707L554.879 94.0707L554.879 113.271Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 109.571L619.618 109.571L619.618 97.7709L614.118 97.7709L614.118 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 109.571L612.396 109.571L612.396 97.7709L606.896 97.7709L606.896 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 109.571L605.176 109.571L605.176 97.7709L599.676 97.7709L599.676 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 109.571L597.954 109.571L597.954 97.7709L592.454 97.7709L592.454 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 109.571L590.733 109.571L590.733 97.7709L585.233 97.7709L585.233 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 109.571L583.512 109.571L583.512 97.7709L578.012 97.7709L578.012 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 109.571L576.291 109.571L576.291 97.7709L570.791 97.7709L570.791 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 109.571L569.17 109.571L569.17 97.7709L563.67 97.7709L563.67 109.571Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 109.571L619.339 109.571L619.339 97.7709L613.839 97.7709L613.839 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 109.571L612.117 109.571L612.117 97.7709L606.617 97.7709L606.617 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 109.571L604.896 109.571L604.896 97.7709L599.396 97.7709L599.396 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 109.571L597.775 109.571L597.775 97.7709L592.275 97.7709L592.275 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 109.571L590.554 109.571L590.554 97.7709L585.054 97.7709L585.054 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 109.571L583.333 109.571L583.333 97.7709L577.833 97.7709L577.833 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 109.571L576.111 109.571L576.111 97.7709L570.611 97.7709L570.611 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 109.571L568.891 109.571L568.891 97.7709L563.391 97.7709L563.391 109.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 110.591L619.339 110.591L619.339 109.591L613.839 109.591L613.839 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 110.591L612.117 110.591L612.117 109.591L606.617 109.591L606.617 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 110.591L604.896 110.591L604.896 109.591L599.396 109.591L599.396 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 110.591L597.775 110.591L597.775 109.591L592.275 109.591L592.275 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 110.591L590.554 110.591L590.554 109.591L585.054 109.591L585.054 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 110.591L583.333 110.591L583.333 109.591L577.833 109.591L577.833 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 110.591L576.111 110.591L576.111 109.591L570.611 109.591L570.611 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 110.591L568.891 110.591L568.891 109.591L563.391 109.591L563.391 110.591Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 110.591L619.936 110.591L619.936 109.591L614.436 109.591L614.436 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 110.591L612.714 110.591L612.714 109.591L607.214 109.591L607.214 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 110.591L605.493 110.591L605.493 109.591L599.993 109.591L599.993 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 110.591L598.372 110.591L598.372 109.591L592.872 109.591L592.872 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 110.591L591.15 110.591L591.15 109.591L585.65 109.591L585.65 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 110.591L583.93 110.591L583.93 109.591L578.43 109.591L578.43 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 110.591L576.709 110.591L576.709 109.591L571.209 109.591L571.209 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 110.591L569.487 110.591L569.487 109.591L563.987 109.591L563.987 110.591Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 99.5624L568.98 99.5624L568.98 97.7624L563.38 97.7624L563.38 99.5624Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 99.0552L576.178 99.0552L576.178 97.7552L570.578 97.7552L570.578 99.0552Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 99.5624L583.414 99.5624L583.414 97.7624L577.814 97.7624L577.814 99.5624Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 99.6893L590.636 99.6893L590.636 97.7893L585.036 97.7893L585.036 99.6893Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 99.0552L597.857 99.0552L597.857 97.7552L592.257 97.7552L592.257 99.0552Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 98.8401L604.979 98.8401L604.979 97.7401L599.379 97.7401L599.379 98.8401Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.618 99.5601L612.218 99.5601L612.218 97.7601L606.618 97.7601L606.618 99.5601Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 99.4529L619.421 99.4529L619.421 97.7529L613.821 97.7529L613.821 99.4529Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 94.1H544.4V113.3H554.9V94.1Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.7 109.1H547.4V110.2H550.7V109.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 110.5H545.501V111.6H548.801V110.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 94.144L624.195 94.144L624.195 93.244L554.895 93.244L554.895 94.144Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 93.1902L624.195 93.1902L624.195 92.2902L554.895 92.2902L554.895 93.1902Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 93.2H543.801V94.1H554.901V93.2Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 92.3999H543.801V93.2999H554.901V92.3999Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 92.3999H543.801V94.1999H554.901V92.3999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 50.4714L623.079 50.4714L623.079 31.2714L554.879 31.2714L554.879 50.4714Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 46.8716L619.618 46.8716L619.618 35.0716L614.118 35.0716L614.118 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 46.8716L612.396 46.8716L612.396 35.0716L606.896 35.0716L606.896 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 46.8716L605.176 46.8716L605.176 35.0716L599.676 35.0716L599.676 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 46.8716L597.954 46.8716L597.954 35.0716L592.454 35.0716L592.454 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 46.8716L590.733 46.8716L590.733 35.0716L585.233 35.0716L585.233 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 46.8716L583.512 46.8716L583.512 35.0716L578.012 35.0716L578.012 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 46.8716L576.291 46.8716L576.291 35.0716L570.791 35.0716L570.791 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 46.8716L569.17 46.8716L569.17 35.0716L563.67 35.0716L563.67 46.8716Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 46.8716L619.339 46.8716L619.339 35.0716L613.839 35.0716L613.839 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 46.8716L612.117 46.8716L612.117 35.0716L606.617 35.0716L606.617 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 46.8716L604.896 46.8716L604.896 35.0716L599.396 35.0716L599.396 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 46.8716L597.775 46.8716L597.775 35.0716L592.275 35.0716L592.275 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 46.8716L590.554 46.8716L590.554 35.0716L585.054 35.0716L585.054 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 46.8716L583.333 46.8716L583.333 35.0716L577.833 35.0716L577.833 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 46.8716L576.111 46.8716L576.111 35.0716L570.611 35.0716L570.611 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 46.8716L568.891 46.8716L568.891 35.0716L563.391 35.0716L563.391 46.8716Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 47.892L619.339 47.892L619.339 46.892L613.839 46.892L613.839 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 47.892L612.117 47.892L612.117 46.892L606.617 46.892L606.617 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 47.892L604.896 47.892L604.896 46.892L599.396 46.892L599.396 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 47.892L597.775 47.892L597.775 46.892L592.275 46.892L592.275 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 47.892L590.554 47.892L590.554 46.892L585.054 46.892L585.054 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 47.892L583.333 47.892L583.333 46.892L577.833 46.892L577.833 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 47.892L576.111 47.892L576.111 46.892L570.611 46.892L570.611 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 47.892L568.891 47.892L568.891 46.892L563.391 46.892L563.391 47.892Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 47.892L619.936 47.892L619.936 46.892L614.436 46.892L614.436 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 47.892L612.714 47.892L612.714 46.892L607.214 46.892L607.214 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 47.892L605.493 47.892L605.493 46.892L599.993 46.892L599.993 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 47.892L598.372 47.892L598.372 46.892L592.872 46.892L592.872 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 47.892L591.15 47.892L591.15 46.892L585.65 46.892L585.65 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 47.892L583.93 47.892L583.93 46.892L578.43 46.892L578.43 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 47.892L576.709 47.892L576.709 46.892L571.209 46.892L571.209 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 47.892L569.487 47.892L569.487 46.892L563.987 46.892L563.987 47.892Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 38.6533L568.98 38.6533L568.98 35.0533L563.38 35.0533L563.38 38.6533Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 42.7424L576.178 42.7424L576.178 35.0424L570.578 35.0424L570.578 42.7424Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 42.0402L583.414 42.0402L583.414 35.0402L577.814 35.0402L577.814 42.0402Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 38.9075L590.636 38.9075L590.636 35.1075L585.036 35.1075L585.036 38.9075Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 37.6389L597.857 37.6389L597.857 35.0389L592.257 35.0389L592.257 37.6389Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 36.1406L604.979 36.1406L604.979 35.0406L599.379 35.0406L599.379 36.1406Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.599 38.6533L612.199 38.6533L612.199 35.0533L606.599 35.0533L606.599 38.6533Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 43.9833L619.421 43.9833L619.421 35.0833L613.821 35.0833L613.821 43.9833Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 31.4H544.4V50.6H554.9V31.4Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.7 46.4H547.4V47.5H550.7V46.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 47.7H545.501V48.7999H548.801V47.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.401 47.7H549.101V48.7999H552.401V47.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 31.3446L624.195 31.3446L624.195 30.4446L554.895 30.4446L554.895 31.3446Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 30.4907L624.195 30.4907L624.195 29.5907L554.895 29.5907L554.895 30.4907Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 30.5H543.801V31.4H554.901V30.5Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 29.6H543.801V30.5H554.901V29.6Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 29.6H543.801V31.4H554.901V29.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 71.4045L623.079 71.4045L623.079 52.2045L554.879 52.2045L554.879 71.4045Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 67.7046L619.618 67.7046L619.618 55.9046L614.118 55.9046L614.118 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 67.7046L612.396 67.7046L612.396 55.9046L606.896 55.9046L606.896 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 67.7046L605.176 67.7046L605.176 55.9046L599.676 55.9046L599.676 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 67.7046L597.954 67.7046L597.954 55.9046L592.454 55.9046L592.454 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 67.7046L590.733 67.7046L590.733 55.9046L585.233 55.9046L585.233 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 67.7046L583.512 67.7046L583.512 55.9046L578.012 55.9046L578.012 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 67.7046L576.291 67.7046L576.291 55.9046L570.791 55.9046L570.791 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 67.7046L569.17 67.7046L569.17 55.9046L563.67 55.9046L563.67 67.7046Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 67.7046L619.339 67.7046L619.339 55.9046L613.839 55.9046L613.839 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 67.7046L612.117 67.7046L612.117 55.9046L606.617 55.9046L606.617 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 67.7046L604.896 67.7046L604.896 55.9046L599.396 55.9046L599.396 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 67.7046L597.775 67.7046L597.775 55.9046L592.275 55.9046L592.275 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 67.7046L590.554 67.7046L590.554 55.9046L585.054 55.9046L585.054 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 67.7046L583.333 67.7046L583.333 55.9046L577.833 55.9046L577.833 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 67.7046L576.111 67.7046L576.111 55.9046L570.611 55.9046L570.611 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 67.7046L568.891 67.7046L568.891 55.9046L563.391 55.9046L563.391 67.7046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 68.7252L619.339 68.7252L619.339 67.7252L613.839 67.7252L613.839 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 68.7252L612.117 68.7252L612.117 67.7252L606.617 67.7252L606.617 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 68.7252L604.896 68.7252L604.896 67.7252L599.396 67.7252L599.396 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 68.7252L597.775 68.7252L597.775 67.7252L592.275 67.7252L592.275 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 68.7252L590.554 68.7252L590.554 67.7252L585.054 67.7252L585.054 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 68.7252L583.333 68.7252L583.333 67.7252L577.833 67.7252L577.833 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 68.7252L576.111 68.7252L576.111 67.7252L570.611 67.7252L570.611 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 68.7252L568.891 68.7252L568.891 67.7252L563.391 67.7252L563.391 68.7252Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 68.7252L619.936 68.7252L619.936 67.7252L614.436 67.7252L614.436 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 68.7252L612.714 68.7252L612.714 67.7252L607.214 67.7252L607.214 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 68.7252L605.493 68.7252L605.493 67.7252L599.993 67.7252L599.993 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 68.7252L598.372 68.7252L598.372 67.7252L592.872 67.7252L592.872 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 68.7252L591.15 68.7252L591.15 67.7252L585.65 67.7252L585.65 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 68.7252L583.93 68.7252L583.93 67.7252L578.43 67.7252L578.43 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 68.7252L576.709 68.7252L576.709 67.7252L571.209 67.7252L571.209 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 68.7252L569.487 68.7252L569.487 67.7252L563.987 67.7252L563.987 68.7252Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 57.6962L568.98 57.6962L568.98 55.8962L563.38 55.8962L563.38 57.6962Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 57.1888L576.178 57.1888L576.178 55.8888L570.578 55.8888L570.578 57.1888Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 57.6962L583.414 57.6962L583.414 55.8962L577.814 55.8962L577.814 57.6962Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 57.8231L590.636 57.8231L590.636 55.9231L585.036 55.9231L585.036 57.8231Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 57.1888L597.857 57.1888L597.857 55.8888L592.257 55.8888L592.257 57.1888Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 56.9738L604.979 56.9738L604.979 55.8738L599.379 55.8738L599.379 56.9738Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.618 57.6938L612.218 57.6938L612.218 55.8938L606.618 55.8938L606.618 57.6938Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 57.5867L619.421 57.5867L619.421 55.8867L613.821 55.8867L613.821 57.5867Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 52.3H544.4V71.5H554.9V52.3Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.7 67.3H547.4V68.4H550.7V67.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 68.6H545.501V69.7H548.801V68.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 52.2778L624.195 52.2778L624.195 51.3778L554.895 51.3778L554.895 52.2778Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 51.424L624.195 51.424L624.195 50.5239L554.895 50.5239L554.895 51.424Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 51.4H543.801V52.3H554.901V51.4Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 50.5H543.801V51.4H554.901V50.5Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 50.5H543.801V52.3H554.901V50.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 134.204L623.079 134.204L623.079 115.004L554.879 115.004L554.879 134.204Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 130.504L619.618 130.504L619.618 118.704L614.118 118.704L614.118 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 130.504L612.396 130.504L612.396 118.704L606.896 118.704L606.896 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 130.504L605.176 130.504L605.176 118.704L599.676 118.704L599.676 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 130.504L597.954 130.504L597.954 118.704L592.454 118.704L592.454 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 130.504L590.733 130.504L590.733 118.704L585.233 118.704L585.233 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 130.504L583.512 130.504L583.512 118.704L578.012 118.704L578.012 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 130.504L576.291 130.504L576.291 118.704L570.791 118.704L570.791 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 130.504L569.17 130.504L569.17 118.704L563.67 118.704L563.67 130.504Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 130.504L619.339 130.504L619.339 118.704L613.839 118.704L613.839 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 130.504L612.117 130.504L612.117 118.704L606.617 118.704L606.617 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 130.504L604.896 130.504L604.896 118.704L599.396 118.704L599.396 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 130.504L597.775 130.504L597.775 118.704L592.275 118.704L592.275 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 130.504L590.554 130.504L590.554 118.704L585.054 118.704L585.054 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 130.504L583.333 130.504L583.333 118.704L577.833 118.704L577.833 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 130.504L576.111 130.504L576.111 118.704L570.611 118.704L570.611 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 130.504L568.891 130.504L568.891 118.704L563.391 118.704L563.391 130.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 131.525L619.339 131.525L619.339 130.525L613.839 130.525L613.839 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 131.525L612.117 131.525L612.117 130.525L606.617 130.525L606.617 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 131.525L604.896 131.525L604.896 130.525L599.396 130.525L599.396 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 131.525L597.775 131.525L597.775 130.525L592.275 130.525L592.275 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 131.525L590.554 131.525L590.554 130.525L585.054 130.525L585.054 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 131.525L583.333 131.525L583.333 130.525L577.833 130.525L577.833 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 131.525L576.111 131.525L576.111 130.525L570.611 130.525L570.611 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 131.525L568.891 131.525L568.891 130.525L563.391 130.525L563.391 131.525Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 131.525L619.936 131.525L619.936 130.525L614.436 130.525L614.436 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 131.525L612.714 131.525L612.714 130.525L607.214 130.525L607.214 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 131.525L605.493 131.525L605.493 130.525L599.993 130.525L599.993 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 131.525L598.372 131.525L598.372 130.525L592.872 130.525L592.872 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 131.525L591.15 131.525L591.15 130.525L585.65 130.525L585.65 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 131.525L583.93 131.525L583.93 130.525L578.43 130.525L578.43 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 131.525L576.709 131.525L576.709 130.525L571.209 130.525L571.209 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 131.525L569.487 131.525L569.487 130.525L563.987 130.525L563.987 131.525Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 123.115L568.98 123.115L568.98 118.715L563.38 118.715L563.38 123.115Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 121.008L576.178 121.008L576.178 118.708L570.578 118.708L570.578 121.008Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 122.459L583.414 122.459L583.414 118.659L577.814 118.659L577.814 122.459Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 123.255L590.636 123.255L590.636 118.655L585.036 118.655L585.036 123.255Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 122.131L597.857 122.131L597.857 118.731L592.257 118.731L592.257 122.131Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 121.288L604.979 121.288L604.979 118.688L599.379 118.688L599.379 121.288Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.599 119.997L612.199 119.997L612.199 118.697L606.599 118.697L606.599 119.997Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 120.418L619.421 120.418L619.421 118.718L613.821 118.718L613.821 120.418Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 115H544.4V134.2H554.9V115Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 131.4H545.501V132.5H548.801V131.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.401 131.4H549.101V132.5H552.401V131.4Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 114.977L624.195 114.977L624.195 114.077L554.895 114.077L554.895 114.977Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 114.123L624.195 114.123L624.195 113.223L554.895 113.223L554.895 114.123Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 114.2H543.801V115.1H554.901V114.2Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 113.3H543.801V114.2H554.901V113.3Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 113.3H543.801V115.1H554.901V113.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.879 155.137L623.079 155.137L623.079 135.937L554.879 135.937L554.879 155.137Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.118 151.437L619.618 151.437L619.618 139.637L614.118 139.637L614.118 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.896 151.437L612.396 151.437L612.396 139.637L606.896 139.637L606.896 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.676 151.437L605.176 151.437L605.176 139.637L599.676 139.637L599.676 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.454 151.437L597.954 151.437L597.954 139.637L592.454 139.637L592.454 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.233 151.437L590.733 151.437L590.733 139.637L585.233 139.637L585.233 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.012 151.437L583.512 151.437L583.512 139.637L578.012 139.637L578.012 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.791 151.437L576.291 151.437L576.291 139.637L570.791 139.637L570.791 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.67 151.437L569.17 151.437L569.17 139.637L563.67 139.637L563.67 151.437Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 151.437L619.339 151.437L619.339 139.637L613.839 139.637L613.839 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 151.437L612.117 151.437L612.117 139.637L606.617 139.637L606.617 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 151.437L604.896 151.437L604.896 139.637L599.396 139.637L599.396 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 151.437L597.775 151.437L597.775 139.637L592.275 139.637L592.275 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 151.437L590.554 151.437L590.554 139.637L585.054 139.637L585.054 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 151.437L583.333 151.437L583.333 139.637L577.833 139.637L577.833 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 151.437L576.111 151.437L576.111 139.637L570.611 139.637L570.611 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 151.437L568.891 151.437L568.891 139.637L563.391 139.637L563.391 151.437Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.839 152.458L619.339 152.458L619.339 151.458L613.839 151.458L613.839 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 152.458L612.117 152.458L612.117 151.458L606.617 151.458L606.617 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.396 152.458L604.896 152.458L604.896 151.458L599.396 151.458L599.396 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.275 152.458L597.775 152.458L597.775 151.458L592.275 151.458L592.275 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.054 152.458L590.554 152.458L590.554 151.458L585.054 151.458L585.054 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.833 152.458L583.333 152.458L583.333 151.458L577.833 151.458L577.833 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.611 152.458L576.111 152.458L576.111 151.458L570.611 151.458L570.611 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.391 152.458L568.891 152.458L568.891 151.458L563.391 151.458L563.391 152.458Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.436 152.458L619.936 152.458L619.936 151.458L614.436 151.458L614.436 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.214 152.458L612.714 152.458L612.714 151.458L607.214 151.458L607.214 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.993 152.458L605.493 152.458L605.493 151.458L599.993 151.458L599.993 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.872 152.458L598.372 152.458L598.372 151.458L592.872 151.458L592.872 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.65 152.458L591.15 152.458L591.15 151.458L585.65 151.458L585.65 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.43 152.458L583.93 152.458L583.93 151.458L578.43 151.458L578.43 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.209 152.458L576.709 152.458L576.709 151.458L571.209 151.458L571.209 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.987 152.458L569.487 152.458L569.487 151.458L563.987 151.458L563.987 152.458Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.38 143.219L568.98 143.219L568.98 139.619L563.38 139.619L563.38 143.219Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.578 147.308L576.178 147.308L576.178 139.608L570.578 139.608L570.578 147.308Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.814 146.606L583.414 146.606L583.414 139.606L577.814 139.606L577.814 146.606Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.036 143.473L590.636 143.473L590.636 139.673L585.036 139.673L585.036 143.473Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.257 142.205L597.857 142.205L597.857 139.605L592.257 139.605L592.257 142.205Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.379 140.706L604.979 140.706L604.979 139.606L599.379 139.606L599.379 140.706Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.599 143.219L612.199 143.219L612.199 139.619L606.599 139.619L606.599 143.219Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.821 148.549L619.421 148.549L619.421 139.649L613.821 139.649L613.821 148.549Z",
    fill: "#F0F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.9 135.9H544.4V155.1H554.9V135.9Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.7 151H547.4V152.1H550.7V151Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M548.801 152.3H545.501V153.4H548.801V152.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M552.401 152.3H549.101V153.4H552.401V152.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 135.91L624.195 135.91L624.195 135.01L554.895 135.01L554.895 135.91Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.895 135.057L624.195 135.057L624.195 134.157L554.895 134.157L554.895 135.057Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 135.1H543.801V136H554.901V135.1Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.901 134.2H543.801V135.1H554.901V134.2Z",
    fill: "#E6E8F5"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.901 134.2H543.801V136H554.901V134.2Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M821.1 212.4H-97.3998C-107.2 212.4 -115.3 204.3 -115.3 194.5V127.4C-115.3 117.6 -107.2 109.5 -97.3998 109.5H821.1C830.9 109.5 839 117.6 839 127.4V194.5C839 204.3 830.9 212.4 821.1 212.4Z",
    fill: "#1DB55D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.901 131.3H-71.0992C-72.7992 131.3 -74.1992 129.9 -74.1992 128.2V125.8C-74.1992 124.1 -72.7992 122.7 -71.0992 122.7H864.901C866.601 122.7 868.001 124.1 868.001 125.8V128.2C868.001 129.9 866.601 131.3 864.901 131.3Z",
    fill: "#D1D5E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.7 182.8H-165.5C-174.9 182.8 -182.6 175.1 -182.6 165.7C-182.6 156.3 -174.9 148.6 -165.5 148.6H581.7C591.1 148.6 598.8 156.3 598.8 165.7C598.8 175.1 591.1 182.8 581.7 182.8Z",
    fill: "#53C983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.301 74.6999C801.401 69.4999 796.201 44.2999 795.701 40.2999C795.701 39.9999 795.601 39.6999 795.501 39.3999C795.201 37.9999 795.501 35.5999 796.301 35.0999C797.701 34.1999 797.101 37.5999 797.101 37.5999C797.101 37.5999 797.201 33.0999 798.401 33.0999C799.601 33.0999 798.801 35.0999 799.001 36.1999C798.801 34.9999 799.901 32.2999 800.801 32.3999C802.701 32.4999 800.901 35.9999 800.901 36.3999C800.901 36.1999 800.601 35.0999 801.801 33.6999C803.101 32.1999 804.901 31.1999 805.001 32.2999C805.001 33.7999 803.501 34.0999 803.301 35.3999C803.101 37.1999 803.001 38.6999 803.001 38.6999C803.001 38.6999 803.401 38.1999 804.001 37.6999C804.901 36.8999 805.401 34.8999 806.101 34.8999C807.401 34.9999 806.401 37.8999 805.301 39.9999C804.301 41.7999 803.201 43.6999 803.001 44.1999C802.601 45.2999 810.701 64.6999 813.001 68.8999C817.801 77.6999 825.801 82.8999 825.901 85.8999C826.001 88.9999 820.901 96.0999 817.301 92.0999C811.801 85.5999 807.201 80.0999 804.301 74.6999Z",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.101 122.9C840.101 122.9 814.501 118.9 811.101 126.7C801.901 148 789.101 189.1 786.601 196.8C786.101 198.5 799.301 209.2 800.101 207.6C806.101 196.2 813.701 158.2 820.601 148C820.601 148 837.301 210.1 840.901 210.3C844.601 210.5 855.801 206.4 854.501 203.6C848.601 191 843.701 164.6 843.801 155.4C843.901 146.3 843.401 122.9 840.101 122.9Z",
    fill: "#A9AABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.101 122.9C840.101 122.9 814.501 118.9 811.101 126.7C801.901 148 789.101 189.1 786.601 196.8C786.101 198.5 799.301 209.2 800.101 207.6C806.101 196.2 813.701 158.2 820.601 148C820.601 148 837.301 210.1 840.901 210.3C844.601 210.5 855.801 206.4 854.501 203.6C848.601 191 843.701 164.6 843.801 155.4C844.001 146.3 843.401 122.9 840.101 122.9Z",
    fill: "#A9AABD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.001 92.6C848.101 93.4 843.401 92.6 843.101 98.1C842.801 105.2 844.401 123.6 842.301 125.7C835.001 132.8 811.101 130.2 811.101 127.2C811.101 121.1 812.101 91.9 812.701 90.4C813.301 88.5 806.901 82.4 806.701 79.8C806.401 76.9 812.601 72.6 816.101 71.6C820.901 76.1 826.601 75.7 839.501 76.9C847.901 77.7 849.701 86.2 850.001 92.6Z",
    fill: "#54547A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.8 55.5C842.8 55.5 842.8 66.6 839.4 68.5C836 70.3 833.2 69.6999 833.2 69.6999L841.4 55.2L842.8 55.5Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M827.4 65.8C826.6 68.4 824.1 74.5 823.4 75.8C822.7 77.1 827.3 83.7 834.7 80L837.4 64.6C837.4 64.6 829.3 59.5 827.4 65.8Z",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.901 49.6C823.301 53.5 821.201 59.6 820.801 65.6C820.401 71.6 821.801 76.5 829.501 72.3C833.901 69.9 839.601 66.6 839.901 62C840.001 60.7 841.801 54.6 841.101 53.1C839.901 50.2 825.501 48.3 824.901 49.6Z",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M826.401 64.1C825.901 64.1 824.601 64 824.501 63.1C824.401 62.2 826.401 59.5 827.001 58.7C827.101 58.6 827.301 58.5 827.401 58.6C827.501 58.7 827.601 58.9 827.501 59C826.301 60.5 825.101 62.5 825.101 62.9C825.101 63.3 826.101 63.4 826.601 63.4C826.801 63.4 826.901 63.5 826.901 63.7C826.901 63.9 826.801 64 826.601 64C826.601 64.1 826.501 64.1 826.401 64.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M830.401 61.2C830.842 61.2 831.201 60.8418 831.201 60.4C831.201 59.9582 830.842 59.6 830.401 59.6C829.959 59.6 829.601 59.9582 829.601 60.4C829.601 60.8418 829.959 61.2 830.401 61.2Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.7 59.7C825.142 59.7 825.5 59.3418 825.5 58.9C825.5 58.4582 825.142 58.1 824.7 58.1C824.259 58.1 823.9 58.4582 823.9 58.9C823.9 59.3418 824.259 59.7 824.7 59.7Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.4 70.3C833.9 73.3 826.9 81.4 823.3 79.4C820.4 77.8 818.1 71.9 820.8 66C821.6 64.2 824.9 65.2 826.3 65.5C828.7 66.1 834.8 67.9 834.4 70.3Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.801 68.8L837.401 58.5C837.401 58.5 837.401 58.5 837.401 58.4C837.501 58.1 838.401 56.3 836.801 55.3C835.101 54.2 825.201 53.8 822.101 53.2C819.901 52.8 819.101 50 818.901 48.4C818.801 48 819.301 47.7 819.701 47.9L822.301 49.6C822.601 49.8 823.001 49.6 823.101 49.2L823.201 47.5C823.201 47.1 823.801 46.9 824.101 47.2L825.101 48.3C825.201 48.4 825.401 48.5 825.601 48.5C826.201 48.4 828.001 48.2 832.801 48.8C838.001 49.4 839.401 50.4 839.801 50.9C839.901 51 840.001 51.1 840.201 51.1C840.701 51.1 841.701 51.2 842.401 51.9C843.301 52.9 843.001 62.1 841.301 63.5C840.301 64.3 839.601 62.6 839.101 62.7C838.001 63 837.801 63.5 837.601 63.8C836.801 65 835.201 70.3 833.701 71.7C832.201 73.1 833.301 71.2 832.701 71C832.401 70.8 832.701 69 832.801 68.8Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.401 58.4C832.301 58.4 832.101 58.3 832.101 58.2C832.101 58.2 831.501 57.4 830.001 57.6C829.801 57.6 829.601 57.5 829.501 57.2C829.501 57 829.601 56.8 829.901 56.7C831.901 56.5 832.701 57.6 832.801 57.7C832.901 57.9 832.901 58.2 832.701 58.3C832.601 58.4 832.501 58.4 832.401 58.4Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.8 56.8C826.7 56.8 826.5 56.7 826.5 56.6C825.9 55.8 824.2 56.3 824.2 56.3C824 56.4 823.7 56.2 823.7 56C823.6 55.8 823.8 55.5 824 55.5C824.1 55.5 826.3 54.8 827.2 56.1C827.3 56.3 827.3 56.6 827.1 56.7C827 56.7 826.9 56.8 826.8 56.8Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.7 66.3C836.7 66.3 838 67.3 839 67.2C840.4 67 841.5 65.1 841.4 63.8C841.3 62.5 839.1 62 838.2 62.4",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M838.401 65.6C838.201 65.6 838.001 65.4 838.101 65.2C838.101 65 838.301 64 838.901 63.8C839.201 63.7 839.601 63.8 839.901 64.2C840.001 64.3 840.001 64.5 839.901 64.7C839.801 64.8 839.601 64.8 839.401 64.7C839.201 64.5 839.101 64.4 839.001 64.5C838.801 64.5 838.701 65 838.601 65.4C838.701 65.4 838.601 65.6 838.401 65.6Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M827.201 68.8C826.301 68.8 824.801 68.5999 823.701 67.6999C823.501 67.4999 823.501 67.3 823.701 67.1C823.901 66.9 824.101 66.9 824.301 67.1C825.501 68.3 827.801 68 827.901 68C828.101 68 828.301 68.1 828.401 68.4C828.401 68.6 828.301 68.8 828.001 68.9C828.001 68.8 827.701 68.8 827.201 68.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.101 126.1C811.101 126.1 814.501 128.9 823.001 129.7C831.601 130.5 842.301 125.7 842.301 125.7L842.701 130.4C842.701 130.4 832.001 133.8 823.401 132.5C814.801 131.2 810.501 128.2 810.501 128.2L811.101 126.1Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.101 134.2L819.101 133.6C818.401 133.5 817.901 132.9 818.001 132.2L818.401 129.5C818.501 128.8 819.101 128.3 819.801 128.4L823.801 129C824.501 129.1 825.001 129.7 824.901 130.4L824.501 133.1C824.401 133.8 823.801 134.3 823.101 134.2Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M820.601 144.8C820.401 144.8 820.301 144.7 820.301 144.5L819.601 136.9C819.601 136.7 819.701 136.6 819.901 136.6C820.101 136.6 820.201 136.7 820.201 136.9L820.901 144.5C821.001 144.7 820.801 144.8 820.601 144.8Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M851.001 204.7C850.901 204.7 850.701 204.6 850.701 204.5C850.601 204.3 844.001 180.8 842.401 174.8C840.901 168.8 838.801 132.9 838.701 131.4C838.701 131.2 838.801 131.1 839.001 131.1C839.201 131.1 839.301 131.2 839.301 131.4C839.301 131.8 841.501 168.8 843.001 174.7C844.501 180.7 851.201 204.1 851.301 204.3C851.301 204.5 851.301 204.7 851.001 204.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M797.301 202.3C797.101 202.3 797.001 202.1 797.001 202C797.501 196 815.701 143.9 816.501 141.7C816.601 141.5 816.701 141.5 816.901 141.5C817.101 141.6 817.101 141.7 817.101 141.9C816.901 142.4 798.101 196.1 797.601 202.1C797.601 202.2 797.401 202.3 797.301 202.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M850.201 106.4C850.001 111.8 849.101 133.9 848.401 138.9C848.401 139.3 848.301 139.7 848.301 140.1C848.201 141.9 848.801 145 848.101 145.8C847.201 146.9 846.101 141.6 846.101 141.6C846.101 141.6 846.201 147.5 845.001 148C844.901 148.1 844.801 148 844.701 148C844.001 147.3 843.501 144 843.601 142.6C843.401 144.1 843.701 147.8 842.801 148C841.701 148.2 841.701 142.2 841.701 141.7C841.601 142.1 840.901 145.9 839.601 145.7C838.301 145.5 840.101 138.2 840.101 138.2C840.101 138.2 838.701 139 837.501 138.5C836.301 138 840.901 133 841.701 131.7C842.401 130.5 841.401 111 841.601 106.5C842.001 97.3 838.701 89.4 839.901 87.1C841.201 84.6 847.701 81.7 848.401 86.5C848.401 86.5 848.401 86.5 848.401 86.6C849.601 94.3 850.401 100.8 850.201 106.4Z",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.201 81.1C839.201 81.1 847.301 82 848.401 85.1C849.501 88.2 850.601 95 850.601 95C850.601 95 849.401 97 843.901 96.3C838.401 95.6 830.801 93.6 830.801 93.6C830.801 93.6 827.301 87.4 830.001 85.8C832.701 84.2 839.201 81.1 839.201 81.1Z",
    fill: "#54557B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.001 41.4999L801.901 38.0999C801.201 37.6999 801.101 36.7999 801.501 36.0999L810.501 22.4999C810.901 21.7999 811.801 21.6999 812.501 22.0999L817.601 25.4999C818.301 25.8999 818.401 26.7999 818.001 27.4999L809.001 41.0999C808.501 41.7999 807.601 41.8999 807.001 41.4999Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M802.201 40.1999C802.201 40.1999 803.501 39.1999 804.001 38.6999C804.801 37.9999 805.201 36.2999 805.801 36.2999C806.901 36.3999 806.101 38.8999 805.101 40.5999C804.201 42.0999 803.301 43.6999 803.101 44.1999C802.801 45.1999 802.201 40.1999 802.201 40.1999Z",
    fill: "#ECBBB2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M799.601 41.4999C799.501 41.4999 799.501 41.4999 799.601 41.4999C799.301 41.3999 799.201 41.2999 799.301 41.0999C799.701 39.4999 802.101 38.8999 802.201 38.8999C802.401 38.8999 802.601 38.9999 802.601 39.0999C802.601 39.2999 802.501 39.4999 802.401 39.4999C802.401 39.4999 800.301 39.9999 800.001 41.1999C799.801 41.3999 799.701 41.4999 799.601 41.4999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M807 26.6C806.9 26.6 806.8 26.6 806.8 26.5L806.4 26.3C806.2 26.2 806.1 25.9 806.3 25.7C806.4 25.5 806.7 25.4 806.9 25.6L807.3 25.8C807.5 25.9 807.6 26.2 807.4 26.4C807.3 26.5 807.1 26.6 807 26.6Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.001 31.9C814.901 31.9 814.801 31.9 814.801 31.8L814.101 31.4C813.901 31.3 813.801 31 814.001 30.8C814.101 30.6 814.401 30.5 814.601 30.7L815.301 31.1C815.501 31.2 815.601 31.5 815.401 31.7C815.301 31.9 815.101 31.9 815.001 31.9ZM813.001 30.6C812.901 30.6 812.801 30.6 812.801 30.5L812.101 30.1C811.901 30 811.801 29.7 812.001 29.5C812.101 29.3 812.401 29.2 812.601 29.4L813.301 29.8C813.501 29.9 813.601 30.2 813.401 30.4C813.301 30.5 813.101 30.6 813.001 30.6ZM811.001 29.2C810.901 29.2 810.801 29.2 810.801 29.1L810.101 28.7C809.901 28.6 809.801 28.3 810.001 28.1C810.101 27.9 810.401 27.8 810.601 28L811.301 28.4C811.501 28.5 811.601 28.8 811.401 29C811.301 29.2 811.101 29.2 811.001 29.2ZM809.001 27.9C808.901 27.9 808.801 27.9 808.801 27.8L808.101 27.4C807.901 27.3 807.801 27 808.001 26.8C808.101 26.6 808.401 26.5 808.601 26.7L809.301 27.1C809.501 27.2 809.601 27.5 809.401 27.7C809.301 27.8 809.101 27.9 809.001 27.9Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M816.701 33.1C816.601 33.1 816.501 33.1 816.501 33L816.101 32.8C815.901 32.7 815.801 32.4 816.001 32.2C816.101 32 816.401 31.9 816.601 32.1L817.001 32.3C817.201 32.4 817.301 32.7 817.101 32.9C817.001 33 816.801 33.1 816.701 33.1Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.501 108.1C740.501 108.1 712.601 79.6 713.001 78C713.401 76.4 705.701 55.6 704.601 46.1C703.501 36.6 702.501 23.2 705.101 21.6C706.701 20.6 705.401 24.8 706.201 28.3C706.201 28.3 705.901 17.5 709.201 18.8C710.601 19.3 708.701 28.2 708.701 28.2C708.701 28.2 710.101 18.5 711.901 18.7C713.701 19 712.101 28.2 712.101 28.2C712.101 28.2 713.501 19.6 715.001 19.5C716.501 19.4 715.201 25.7 714.701 28.9C714.201 31.8 714.401 32.1 714.401 32.1C716.201 32.3 713.601 37.5 712.801 38C712.001 38.5 719.201 64.4 722.701 70.7C726.301 77 743.001 92.1 743.001 92.1L740.501 108.1Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.4 93.7C752.2 87.4 744.5 85.1 734.6 79.4C730.8 77.2 716.9 88.8 716.9 88.8C716.9 88.8 728.8 104 737.3 106.6C745.8 109.2 754.6 100.1 753.4 93.7Z",
    fill: "#D16E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.601 155.2C778.601 155.2 780.601 201 780.701 219.6C780.801 238.2 796.501 271.3 796.501 271.3C796.501 271.3 709.201 303.6 708.801 285.4C707.801 235.7 729.701 162.8 729.701 162.8L778.601 155.2Z",
    className: "illustration_primary"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.801 90.2C776.101 84.5 746.801 84.5 743.001 84.7C735.101 85.2 733.201 115.7 735.201 125.5C739.801 147.9 732.301 149.3 730.101 160.5C727.901 171.4 736.201 173.9 758.001 173.9C779.801 173.9 780.201 163.6 780.201 163.6C780.201 163.6 792.601 101.1 781.801 90.2Z",
    fill: "#D16E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.101 162.4C775.001 162.2 778.801 138.6 778.501 132.2C778.401 130.8 772.201 104.3 772.201 104.3C772.201 104.3 780.401 99.6 782.801 101C789.401 104.9 789.001 131.6 788.901 133.5C788.901 134.9 786.701 154.1 784.401 162C782.101 169.9 780.901 177.3 779.101 180.3C778.401 181.4 775.301 187.1 773.901 186.2C772.701 185.4 776.801 181.3 776.901 179.7C776.601 181.6 770.801 188.5 769.101 186.4C768.401 185.5 774.001 179.1 774.401 177.9C773.901 179.3 767.701 186 766.601 185.1C765.801 184.4 770.901 178.6 771.201 177.2C770.801 178.4 765.201 183.8 764.501 183.4C763.101 182.7 768.601 176.9 769.801 173.2C771.001 169.5 771.001 169 771.001 169C771.001 169 766.301 172.8 765.301 170.1C764.701 168.3 773.101 162.6 774.101 162.4Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.1 88.3C746.1 90.4 744.5 100.2 750.1 100.2C755.8 100.2 766.6 90.4 766.6 88.3C766.6 86.2 762 84.5 756.3 84.5C750.7 84.5 746.1 86.2 746.1 88.3Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.501 44.4C768.501 44.4 767.801 78.9 764.801 81.8C761.701 84.7 733.701 79.5 733.701 79.5C733.701 79.5 733.501 53.1 739.401 43.7C742.701 38.4 750.101 34.5 768.501 44.4Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.601 57.5999L769.401 65.8999C769.401 65.8999 772.001 67.3999 773.901 66.6999C776.301 65.8999 777.301 62.8999 776.901 60.3999C776.901 60.0999 776.801 59.7999 776.701 59.4999C776.601 59.2999 776.501 59.0999 776.401 58.8999C776.101 58.2999 775.801 57.8999 775.301 57.5999C775.001 57.5999 774.701 57.7999 774.601 57.9999C774.501 58.1999 774.201 58.1999 774.001 57.9999C773.801 57.8999 773.801 57.5999 774.001 57.3999C774.101 57.2999 774.301 57.0999 774.501 56.9999C773.201 56.4999 771.601 56.7999 770.601 57.5999Z",
    fill: "#E5C983"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.701 40.3C743.001 47.6 738.501 54.7 738.801 65.9C739.101 77.1 743.601 84.4 761.501 78.2C772.401 74.4 771.701 66.2 771.601 57.7C771.601 55.3 771.101 48.8 769.201 46C765.701 40.5 746.601 37.9 745.701 40.3Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.301 60.9001C744.019 60.9001 744.601 60.318 744.601 59.6C744.601 58.8821 744.019 58.3 743.301 58.3C742.583 58.3 742.001 58.8821 742.001 59.6C742.001 60.318 742.583 60.9001 743.301 60.9001Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.801 62.6C754.519 62.6 755.101 62.018 755.101 61.3C755.101 60.582 754.519 60 753.801 60C753.083 60 752.501 60.582 752.501 61.3C752.501 62.018 753.083 62.6 753.801 62.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.401 68.0999C747.301 68.0999 747.301 68.0999 747.201 68.0999L744.301 66.8999C744.101 66.7999 744.001 66.6999 744.001 66.4999C744.001 66.2999 744.001 66.0999 744.101 65.9999L748.101 60.8999C748.301 60.6999 748.701 60.5999 748.901 60.7999C749.101 60.9999 749.201 61.3999 749.001 61.5999L745.401 66.0999L747.601 66.9999C747.901 67.0999 748.001 67.4999 747.901 67.6999C747.801 67.9999 747.601 68.0999 747.401 68.0999Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M755.901 93.1C758.501 93.5 763.101 90.7 763.701 87.7L765.801 77.3C766.401 74.3 764.501 71.3 761.401 70.7L759.001 70.2C756.001 69.6 753.001 71.5 752.401 74.6L750.301 85C749.701 88 750.201 92.3 755.901 93.1Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M755.901 79.9C755.701 79.9 755.601 79.8 755.601 79.6C755.601 79.4 755.701 79.2 755.901 79.2C756.001 79.2 761.801 78.1 765.501 74.7C765.601 74.6 765.901 74.6 766.001 74.7C766.101 74.8 766.101 75.1 766.001 75.2C762.101 78.7 756.201 79.8 755.901 79.9Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M748.301 52C746.501 51.6 743.101 49.9999 742.201 42.5999C742.001 41.2999 741.801 37.8 748.901 36.9C755.001 36.1 759.801 38.6 758.701 42.9C745.701 44.7 751.601 52.7999 748.301 52Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.001 58.9C756.801 58.9 756.701 58.8 756.601 58.7C755.601 57 752.501 57.3 752.501 57.3C752.201 57.3 752.001 57.1 752.001 56.9C752.001 56.7 752.201 56.4 752.401 56.4C752.601 56.4 756.201 56.1 757.401 58.3C757.501 58.5 757.501 58.8 757.201 58.9C757.201 58.8 757.101 58.9 757.001 58.9Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.401 56.1C746.301 56.1 746.301 56.1 746.201 56.1C746.201 56.1 744.101 55.2 742.001 55.9C741.801 56 741.501 55.9 741.401 55.6C741.301 55.4 741.401 55.1 741.701 55C744.201 54.2 746.501 55.2 746.601 55.2C746.801 55.3 746.901 55.6 746.801 55.8C746.801 56 746.601 56.1 746.401 56.1Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.801 40.6C749.801 40.6 748.001 49.3 752.601 49.9C757.201 50.6 762.101 52.1 764.501 55.7C766.901 59.3 762.501 80.1 759.401 85.5L776.601 85C776.601 85 778.801 56.9 775.101 46.3C773.001 40.2 762.001 31.1 749.801 40.6Z",
    className: "illustration_primary_default"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.001 68.4C767.001 68.4 769.601 69.9 771.501 69.2C774.401 68.2 775.201 63.9 774.001 61.3C772.801 58.7 769.701 58.7 768.101 60L767.001 68.4Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M772.101 59.5999C772.401 59.6999 772.701 59.8999 773.001 60.0999C773.701 59.9999 774.401 60.4999 774.501 61.1999C774.601 61.4999 774.501 61.8999 774.301 62.0999C774.101 62.3999 773.801 62.5999 773.401 62.6999C773.201 62.6999 773.101 62.6999 772.901 62.6999C772.701 62.6999 772.501 62.7999 772.401 62.9999C772.401 63.1999 772.501 63.3999 772.701 63.4999C773.001 63.5999 773.301 63.5999 773.501 63.4999C773.901 63.3999 774.201 63.2999 774.501 63.0999C775.101 62.5999 775.401 61.8999 775.301 61.0999C775.101 59.9999 774.001 59.1999 772.901 59.3999C772.601 59.2999 772.301 59.3999 772.101 59.5999Z",
    fill: "#FFE000"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M770.001 66.7C769.801 66.7 769.601 66.6 769.501 66.4C769.101 65.5 769.001 64.7 769.301 64C769.701 63 770.701 62.6 770.701 62.6C771.001 62.5 771.301 62.6 771.401 62.9C771.501 63.2 771.401 63.5 771.101 63.6C771.101 63.6 770.501 63.8 770.301 64.4C770.101 64.8 770.201 65.3 770.501 65.8C770.601 66.1 770.501 66.4 770.201 66.6C770.201 66.6 770.101 66.7 770.001 66.7Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M747.801 74.1C745.801 74.1 743.701 73.4 742.501 71.2C742.301 70.9 742.501 70.6 742.701 70.4C742.901 70.2 743.301 70.4 743.501 70.6C745.701 74.7 751.501 72.1 751.701 72C752.001 71.9 752.301 72 752.501 72.3C752.601 72.6 752.501 72.9 752.201 73.1C751.101 73.7 749.501 74.1 747.801 74.1Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M766.601 91.5C766.601 91.5 774.701 105.8 771.901 116.2L789.401 114.7C789.401 114.7 788.801 96.9 782.701 91C776.501 85.1 771.701 89.5 766.601 91.5Z",
    fill: "#D16E42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.001 33.3L706.701 27.5C705.501 26.4 705.501 24.7 706.501 23.7L723.001 5.8C724.001 4.7 725.701 4.7 726.701 5.6L733.001 11.4C734.101 12.4 734.101 14.1 733.201 15.1L716.701 33C715.701 34.1 714.001 34.2 713.001 33.3Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.401 10.4C716.201 10.4 716.001 10.3 715.901 10.2L715.401 9.69998C715.101 9.39998 715.101 8.99998 715.401 8.69998C715.701 8.39998 716.101 8.39998 716.401 8.69998L716.901 9.19998C717.201 9.49998 717.201 9.89998 716.901 10.2C716.801 10.4 716.601 10.4 716.401 10.4Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.701 21.2C727.501 21.2 727.301 21.1 727.201 21L726.301 20.1C726.001 19.8 726.001 19.4 726.301 19.1C726.601 18.8 727.001 18.8 727.301 19.1L728.201 20C728.501 20.3 728.501 20.7 728.201 21C728.001 21.1 727.901 21.2 727.701 21.2ZM724.901 18.5C724.701 18.5 724.501 18.4 724.401 18.3L723.501 17.4C723.201 17.1 723.201 16.7 723.501 16.4C723.801 16.1 724.201 16.1 724.501 16.4L725.401 17.3C725.701 17.6 725.701 18 725.401 18.3C725.201 18.4 725.001 18.5 724.901 18.5ZM722.001 15.8C721.801 15.8 721.601 15.7 721.501 15.6L720.601 14.7C720.301 14.4 720.301 14 720.601 13.7C720.901 13.4 721.301 13.4 721.601 13.7L722.501 14.6C722.801 14.9 722.801 15.3 722.501 15.6C722.401 15.7 722.201 15.8 722.001 15.8ZM719.201 13.1C719.001 13.1 718.801 13 718.701 12.9L717.801 12C717.501 11.7 717.501 11.3 717.801 11C718.101 10.7 718.501 10.7 718.801 11L719.701 11.9C720.001 12.2 720.001 12.6 719.701 12.9C719.601 13 719.401 13.1 719.201 13.1Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.101 23.5C729.901 23.5 729.701 23.4 729.601 23.3L729.101 22.8C728.801 22.5 728.801 22.1 729.101 21.8C729.401 21.5 729.801 21.5 730.101 21.8L730.601 22.3C730.901 22.6 730.901 23 730.601 23.3C730.401 23.4 730.201 23.5 730.101 23.5Z",
    fill: "#2A9DD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.4 32.4999C710.3 32.0999 711.9 32.2 713.6 30.7C715 29.4 714.8 25.1 716.3 26.1C719 27.8 716.3 34.0999 712.8 38.2999C712.2 38.9999 709.4 32.4999 709.4 32.4999Z",
    fill: "#FCBD4C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.701 33.7C706.601 33.7 706.501 33.7 706.501 33.6C706.301 33.5 706.301 33.3 706.401 33.1C707.601 31.6 710.701 31.6 710.801 31.6C711.001 31.6 711.201 31.8 711.201 32C711.201 32.2 711.001 32.4 710.801 32.4C710.701 32.4 707.901 32.4 707.001 33.6C707.001 33.6 706.801 33.7 706.701 33.7Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20994_306983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 160,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWidgetEvent);
export default __webpack_public_path__ + "static/media/BackgroundWidgetEvent.18d459ba.svg";
export { ForwardRef as ReactComponent };